// // // SalesEnquiry.jsx
// // import React, { useState, useEffect } from 'react';
// // import { 
// //     FaPlus, FaEye, FaEdit, FaTrash, FaTimes, 
// //     FaUser, FaEnvelope, FaPhone, FaBuilding, 
// //     FaMapMarkerAlt, FaCalendarAlt, FaUtensils,
// //     FaCheckCircle, FaSearch, FaFilter, FaClock,
// //     FaSpinner, FaSync
// // } from 'react-icons/fa';
// // import { 
// //     getAllDishes, 
// //     createEnquiry, 
// //     getAllEnquiries, 
// //     deleteEnquiry,
// //     ENUMS 
// // } from '../../Servicefile/salesService';

// // const SalesEnquiry = () => {
// //     const [showCreateModal, setShowCreateModal] = useState(false);
// //     const [showEditModal, setShowEditModal] = useState(false);
// //     const [searchTerm, setSearchTerm] = useState('');
// //     const [filterType, setFilterType] = useState('all');
// //     const [loading, setLoading] = useState(false);
// //     const [submitting, setSubmitting] = useState(false);
// //     const [enquiries, setEnquiries] = useState([]);
// //     const [dishes, setDishes] = useState([]);
// //     const [editingEnquiry, setEditingEnquiry] = useState(null);

// //     // Form state
// //     const [formData, setFormData] = useState({
// //         source: 'APP',
// //         sourceBy: '',
// //         fullName: '',
// //         email: '',
// //         phoneNumber: '',
// //         event: 'EVENT',
// //         eventType: 'WEDDING',
// //         eventDate: '',
// //         eventTime: '',
// //         fromDate: '',
// //         toDate: '',
// //         fullAddress: '',
// //         city: '',
// //         state: '',
// //         country: 'India',
// //         companyName: '',
// //         vegPlates: 0,
// //         nonVegPlates: 0,
// //         mixedPlates: 0,
// //         additionalRequests: '',
// //         adminPermision: false,
// //         leadStatus: 'PENDING',
// //         budget: 0,
// //         latitude: 0,
// //         longitude: 0,
// //         pincode: '',
// //         gstRequirement: '',
// //         dishId: [],
// //         addOns: []
// //     });

// //     // Add-ons state
// //     const addOnOptions = [
// //         { addOnType: 'SERVICE_BOYS', label: 'Service Boys', selected: false, quantity: 0 },
// //         { addOnType: 'PAPER_PLATES', label: 'Paper Plates', selected: false, quantity: 0 },
// //         { addOnType: 'WATER_BOTTLES', label: 'Water Bottles', selected: false, quantity: 0 },
// //         { addOnType: 'DISPOSABLE_CUPS', label: 'Disposable Cups', selected: false, quantity: 0 },
// //         { addOnType: 'TISSUE_PAPER', label: 'Tissue Paper', selected: false, quantity: 0 }
// //     ];

// //     const [addOns, setAddOns] = useState(addOnOptions);
// //     const [selectedDishIds, setSelectedDishIds] = useState([]);

// //     // Fetch dishes on mount
// //     useEffect(() => {
// //         fetchDishes();
// //         fetchEnquiries();
// //     }, []);

// //     // Fetch all dishes
// //     const fetchDishes = async () => {
// //         try {
// //             const data = await getAllDishes();
// //             setDishes(data || []);
// //         } catch (error) {
// //             console.error('Error fetching dishes:', error);
// //         }
// //     };

// //     // Fetch all enquiries
// //     const fetchEnquiries = async () => {
// //         setLoading(true);
// //         try {
// //             const data = await getAllEnquiries();
// //             setEnquiries(data || []);
// //         } catch (error) {
// //             console.error('Error fetching enquiries:', error);
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     // Handle form input changes
// //     const handleInputChange = (e) => {
// //         const { name, value } = e.target;
// //         setFormData(prev => ({ ...prev, [name]: value }));
// //     };

// //     // Handle add-on toggle
// //     const handleAddOnToggle = (index) => {
// //         const updated = [...addOns];
// //         updated[index].selected = !updated[index].selected;
// //         if (!updated[index].selected) {
// //             updated[index].quantity = 0;
// //         }
// //         setAddOns(updated);
// //     };

// //     // Handle add-on quantity
// //     const handleAddOnQuantity = (index, value) => {
// //         const updated = [...addOns];
// //         updated[index].quantity = parseInt(value) || 0;
// //         setAddOns(updated);
// //     };

// //     // Handle dish selection
// //     const handleDishSelect = (dishId) => {
// //         setSelectedDishIds(prev => {
// //             if (prev.includes(dishId)) {
// //                 return prev.filter(id => id !== dishId);
// //             } else {
// //                 return [...prev, dishId];
// //             }
// //         });
// //     };

// //     // Get min date (2 days from today)
// //     const getMinDate = () => {
// //         const date = new Date();
// //         date.setDate(date.getDate() + 2);
// //         return date.toISOString().split('T')[0];
// //     };

// //     // Get max date (3 years from now)
// //     const getMaxDate = () => {
// //         const date = new Date();
// //         date.setFullYear(date.getFullYear() + 3);
// //         return date.toISOString().split('T')[0];
// //     };

// //     // Handle form submit
// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     // Validation
// //     if (!formData.fullName) {
// //         alert('Please enter full name');
// //         return;
// //     }
// //     if (!formData.email) {
// //         alert('Please enter email');
// //         return;
// //     }
// //     if (!formData.phoneNumber) {
// //         alert('Please enter phone number');
// //         return;
// //     }

// //     // Validate date based on event type
// //     if (formData.event === 'EVENT') {
// //         if (!formData.eventDate) {
// //             alert('Please select event date');
// //             return;
// //         }
// //     } else if (formData.event === 'DAILY') {
// //         if (!formData.fromDate || !formData.toDate) {
// //             alert('Please select from and to dates');
// //             return;
// //         }
// //     }

// //     // Prepare add-ons data
// //     const selectedAddOns = addOns
// //         .filter(a => a.selected)
// //         .map(a => ({
// //             addOnType: a.addOnType,
// //             quantity: a.quantity || 1,
// //             selected: true
// //         }));

// //     // ✅ FORMAT DATES FOR API (DD-MM-YYYY)
// //     const requestBody = {
// //         ...formData,
// //         // Format dates to DD-MM-YYYY
// //         eventDate: formData.eventDate ? formatDateForAPI(formData.eventDate) : '',
// //         fromDate: formData.fromDate ? formatDateForAPI(formData.fromDate) : '',
// //         toDate: formData.toDate ? formatDateForAPI(formData.toDate) : '',
// //         // Time stays as is (HH:MM)
// //         eventTime: formData.eventTime || '',
// //         // Other fields
// //         addOns: selectedAddOns,
// //         dishId: selectedDishIds,
// //         pincode: parseInt(formData.pincode) || 0,
// //         budget: parseFloat(formData.budget) || 0,
// //         vegPlates: parseInt(formData.vegPlates) || 0,
// //         nonVegPlates: parseInt(formData.nonVegPlates) || 0,
// //         mixedPlates: parseInt(formData.mixedPlates) || 0
// //     };

// //     setSubmitting(true);
// //     try {
// //         await createEnquiry(requestBody);
// //         alert('Enquiry created successfully!');
// //         setShowCreateModal(false);
// //         resetForm();
// //         fetchEnquiries();
// //     } catch (error) {
// //         console.error('Error creating enquiry:', error);
// //         alert(error.response?.data?.message || 'Failed to create enquiry');
// //     } finally {
// //         setSubmitting(false);
// //     }
// // };

// //     // Reset form
// //     const resetForm = () => {
// //         setFormData({
// //             source: 'APP',
// //             sourceBy: '',
// //             fullName: '',
// //             email: '',
// //             phoneNumber: '',
// //             event: 'EVENT',
// //             eventType: 'WEDDING',
// //             eventDate: '',
// //             eventTime: '',
// //             fromDate: '',
// //             toDate: '',
// //             fullAddress: '',
// //             city: '',
// //             state: '',
// //             country: 'India',
// //             companyName: '',
// //             vegPlates: 0,
// //             nonVegPlates: 0,
// //             mixedPlates: 0,
// //             additionalRequests: '',
// //             adminPermision: false,
// //             leadStatus: 'PENDING',
// //             budget: 0,
// //             latitude: 0,
// //             longitude: 0,
// //             pincode: '',
// //             gstRequirement: '',
// //             dishId: [],
// //             addOns: []
// //         });
// //         setAddOns(addOnOptions);
// //         setSelectedDishIds([]);
// //         setEditingEnquiry(null);
// //     };

// //     // Handle delete enquiry
// //     const handleDelete = async (id) => {
// //         if (!window.confirm('Are you sure you want to delete this enquiry?')) return;

// //         try {
// //             await deleteEnquiry(id);
// //             alert('Enquiry deleted successfully!');
// //             fetchEnquiries();
// //         } catch (error) {
// //             console.error('Error deleting enquiry:', error);
// //             alert('Failed to delete enquiry');
// //         }
// //     };

// //     // Get status badge
// //     const getStatusBadge = (status) => {
// //         const statusMap = {
// //             'PENDING': { style: pendingBadgeStyle, label: 'Pending', icon: <FaClock size={12} /> },
// //             'IN_PROGRESS': { style: quotedBadgeStyle, label: 'In Progress', icon: <FaSync size={12} /> },
// //             'QUOTED': { style: quotedBadgeStyle, label: 'Quoted', icon: <FaCheckCircle size={12} /> },
// //             'APPROVED': { style: approvedBadgeStyle, label: 'Approved', icon: <FaCheckCircle size={12} /> },
// //             'REJECTED': { style: rejectedBadgeStyle, label: 'Rejected', icon: <FaTimes size={12} /> },
// //             'CLOSED': { style: rejectedBadgeStyle, label: 'Closed', icon: <FaTimes size={12} /> }
// //         };
// //         const statusInfo = statusMap[status] || statusMap['PENDING'];
// //         return (
// //             <span style={statusInfo.style}>
// //                 {statusInfo.icon} {statusInfo.label}
// //             </span>
// //         );
// //     };

// //     // Filter enquiries
// //     const filteredEnquiries = enquiries.filter(e => {
// //         const matchesSearch = 
// //             (e.fullName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             (e.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             (e.companyName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             (e.city || '').toLowerCase().includes(searchTerm.toLowerCase());

// //         const matchesFilter = filterType === 'all' || e.leadStatus === filterType;

// //         return matchesSearch && matchesFilter;
// //     });

// //     // Get status count
// //     const getStatusCount = (status) => {
// //         return enquiries.filter(e => e.leadStatus === status).length;
// //     };

// //     // Format date for display
// //     const formatDate = (dateStr) => {
// //         if (!dateStr) return '-';
// //         try {
// //             const date = new Date(dateStr);
// //             return date.toLocaleDateString('en-IN', {
// //                 day: '2-digit',
// //                 month: 'short',
// //                 year: 'numeric'
// //             });
// //         } catch {
// //             return dateStr;
// //         }
// //     };

// //     // Add these helper functions in your component (before the handleSubmit function)

// // // Format date from YYYY-MM-DD to DD-MM-YYYY
// // const formatDateForAPI = (dateStr) => {
// //     if (!dateStr) return '';
// //     const parts = dateStr.split('-');
// //     // Input is YYYY-MM-DD, output should be DD-MM-YYYY
// //     return `${parts[2]}-${parts[1]}-${parts[0]}`;
// // };

// // // Format time from HH:MM to HH:MM (already in correct format)
// // const formatTimeForAPI = (timeStr) => {
// //     if (!timeStr) return '';
// //     return timeStr; // Already in HH:MM format
// // };

// // // Format date from DD-MM-YYYY to display format
// // const formatDateForDisplay = (dateStr) => {
// //     if (!dateStr) return '-';
// //     try {
// //         const parts = dateStr.split('-');
// //         // Input is DD-MM-YYYY, output should be YYYY-MM-DD for display
// //         return `${parts[2]}-${parts[1]}-${parts[0]}`;
// //     } catch {
// //         return dateStr;
// //     }
// // };


// //     // Get total plates
// //     const getTotalPlates = (enquiry) => {
// //         return (enquiry.vegPlates || 0) + (enquiry.nonVegPlates || 0) + (enquiry.mixedPlates || 0);
// //     };

// //     return (
// //         <div style={containerStyle}>
// //             {/* Header */}
// //             <div style={headerStyle}>
// //                 <div style={headerLeftStyle}>
// //                     <h2 style={titleStyle}>Sales Enquiries</h2>
// //                     <span style={countStyle}>{enquiries.length} enquiries</span>
// //                 </div>
// //                 <button
// //                     onClick={() => { resetForm(); setShowCreateModal(true); }}
// //                     style={createButtonStyle}
// //                 >
// //                     <FaPlus size={14} />
// //                     Create Enquiry
// //                 </button>
// //             </div>

// //             {/* Stats Cards */}
// //             <div style={statsContainerStyle}>
// //                 <div style={statCardStyle}>
// //                     <div style={statIconStyle} className="stat-total">📋</div>
// //                     <div>
// //                         <div style={statNumberStyle}>{enquiries.length}</div>
// //                         <div style={statLabelStyle}>Total</div>
// //                     </div>
// //                 </div>
// //                 <div style={statCardStyle}>
// //                     <div style={statIconStyle} className="stat-pending">⏳</div>
// //                     <div>
// //                         <div style={statNumberStyle}>{getStatusCount('PENDING')}</div>
// //                         <div style={statLabelStyle}>Pending</div>
// //                     </div>
// //                 </div>
// //                 <div style={statCardStyle}>
// //                     <div style={statIconStyle} className="stat-quoted">💰</div>
// //                     <div>
// //                         <div style={statNumberStyle}>{getStatusCount('QUOTED')}</div>
// //                         <div style={statLabelStyle}>Quoted</div>
// //                     </div>
// //                 </div>
// //                 <div style={statCardStyle}>
// //                     <div style={statIconStyle} className="stat-approved">✅</div>
// //                     <div>
// //                         <div style={statNumberStyle}>{getStatusCount('APPROVED')}</div>
// //                         <div style={statLabelStyle}>Approved</div>
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Search and Filter */}
// //             <div style={searchFilterContainerStyle}>
// //                 <div style={searchContainerStyle}>
// //                     <FaSearch style={searchIconStyle} />
// //                     <input
// //                         type="text"
// //                         placeholder="Search enquiries..."
// //                         value={searchTerm}
// //                         onChange={(e) => setSearchTerm(e.target.value)}
// //                         style={searchInputStyle}
// //                     />
// //                 </div>
// //                 <div style={filterContainerStyle}>
// //                     <FaFilter style={filterIconStyle} />
// //                     <select
// //                         value={filterType}
// //                         onChange={(e) => setFilterType(e.target.value)}
// //                         style={filterSelectStyle}
// //                     >
// //                         <option value="all">All Status</option>
// //                         <option value="PENDING">Pending</option>
// //                         <option value="QUOTED">Quoted</option>
// //                         <option value="APPROVED">Approved</option>
// //                         <option value="REJECTED">Rejected</option>
// //                         <option value="CLOSED">Closed</option>
// //                     </select>
// //                 </div>
// //                 <button onClick={fetchEnquiries} style={refreshButtonStyle}>
// //                     <FaSync size={14} />
// //                     Refresh
// //                 </button>
// //             </div>

// //             {/* Table */}
// //             <div style={tableCardStyle}>
// //                 {loading ? (
// //                     <div style={loadingStyle}>
// //                         <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={30} />
// //                         <p>Loading enquiries...</p>
// //                     </div>
// //                 ) : (
// //                     <div style={tableWrapperStyle}>
// //                         <table style={tableStyle}>
// //                             <thead>
// //                                 <tr>
// //                                     <th style={{ width: '5%', textAlign: 'center' }}>#</th>
// //                                     <th style={{ width: '14%', textAlign: 'center' }}>Customer</th>
// //                                     <th style={{ width: '10%', textAlign: 'center' }}>Event</th>
// //                                     <th style={{ width: '10%', textAlign: 'center' }}>Date</th>
// //                                     <th style={{ width: '10%', textAlign: 'center' }}>City</th>
// //                                     <th style={{ width: '8%', textAlign: 'center' }}>Plates</th>
// //                                     <th style={{ width: '10%', textAlign: 'center' }}>Budget</th>
// //                                     <th style={{ width: '10%', textAlign: 'center' }}>Status</th>
// //                                     <th style={{ width: '10%', textAlign: 'center' }}>Created</th>
// //                                     <th style={{ width: '13%', textAlign: 'center' }}>Actions</th>
// //                                 </tr>
// //                             </thead>
// //                             <tbody>
// //                                 {filteredEnquiries.length === 0 ? (
// //                                     <tr>
// //                                         <td colSpan="10" style={emptyStateStyle}>
// //                                             No enquiries found
// //                                         </td>
// //                                     </tr>
// //                                 ) : (
// //                                     filteredEnquiries.map((enquiry, index) => (
// //                                         <tr key={enquiry.id || enquiry.enquiryId || index} style={tableRowStyle}>
// //                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>{index + 1}</td>
// //                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>
// //                                                 <div>
// //                                                     <div style={{ fontWeight: 600 }}>{enquiry.fullName || '-'}</div>
// //                                                     <div style={{ fontSize: '11px', color: '#888' }}>{enquiry.email || '-'}</div>
// //                                                 </div>
// //                                             </td>
// //                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>{enquiry.eventType || '-'}</td>
// //                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>
// //                                                 {enquiry.event === 'EVENT' 
// //                                                     ? formatDate(enquiry.eventDate) 
// //                                                     : `${formatDate(enquiry.fromDate)} - ${formatDate(enquiry.toDate)}`}
// //                                             </td>
// //                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>{enquiry.city || '-'}</td>
// //                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>
// //                                                 <span style={platesBadgeStyle}>
// //                                                     {getTotalPlates(enquiry)}
// //                                                 </span>
// //                                             </td>
// //                                             <td style={{ ...tableCellStyle, textAlign: 'center', fontWeight: 600, color: '#e66d33' }}>
// //                                                 ₹{enquiry.budget || 0}
// //                                             </td>
// //                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>
// //                                                 {getStatusBadge(enquiry.leadStatus)}
// //                                             </td>
// //                                             <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '12px', color: '#888' }}>
// //                                                 {formatDate(enquiry.createdAt)}
// //                                             </td>
// //                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>
// //                                                 <div style={actionGroupStyle}>
// //                                                     {/* <button
// //                                                         style={viewButtonStyle}
// //                                                         title="View"
// //                                                         onClick={() => alert(`View enquiry #${enquiry.id || enquiry.enquiryId}`)}
// //                                                     >
// //                                                         <FaEye size={14} />
// //                                                     </button> */}
// //                                                     <button
// //                                                         style={editButtonStyle}
// //                                                         title="Edit"
// //                                                         onClick={() => {
// //                                                             setEditingEnquiry(enquiry);
// //                                                             // Populate form with enquiry data for edit
// //                                                             setShowEditModal(true);
// //                                                         }}
// //                                                     >
// //                                                         <FaEdit size={14} />
// //                                                     </button>
// //                                                     <button
// //                                                         style={deleteButtonStyle}
// //                                                         title="Delete"
// //                                                         onClick={() => handleDelete(enquiry.id || enquiry.enquiryId)}
// //                                                     >
// //                                                         <FaTrash size={14} />
// //                                                     </button>
// //                                                 </div>
// //                                             </td>
// //                                         </tr>
// //                                     ))
// //                                 )}
// //                             </tbody>
// //                         </table>
// //                     </div>
// //                 )}
// //             </div>

// //             {/* Create Enquiry Modal */}
// //             {showCreateModal && (
// //                 <EnquiryModal
// //                     formData={formData}
// //                     setFormData={setFormData}
// //                     addOns={addOns}
// //                     setAddOns={setAddOns}
// //                     dishes={dishes}
// //                     selectedDishIds={selectedDishIds}
// //                     setSelectedDishIds={setSelectedDishIds}
// //                     handleInputChange={handleInputChange}
// //                     handleAddOnToggle={handleAddOnToggle}
// //                     handleAddOnQuantity={handleAddOnQuantity}
// //                     handleDishSelect={handleDishSelect}
// //                     handleSubmit={handleSubmit}
// //                     resetForm={resetForm}
// //                     setShowModal={setShowCreateModal}
// //                     submitting={submitting}
// //                     getMinDate={getMinDate}
// //                     getMaxDate={getMaxDate}
// //                     ENUMS={ENUMS}
// //                     title="Create New Enquiry"
// //                     submitLabel="Create Enquiry"
// //                 />
// //             )}

// //             {/* Edit Enquiry Modal */}
// //             {showEditModal && editingEnquiry && (
// //                 <EnquiryModal
// //                     formData={editingEnquiry}
// //                     setFormData={(data) => setEditingEnquiry(data)}
// //                     addOns={addOns}
// //                     setAddOns={setAddOns}
// //                     dishes={dishes}
// //                     selectedDishIds={selectedDishIds}
// //                     setSelectedDishIds={setSelectedDishIds}
// //                     handleInputChange={(e) => {
// //                         const { name, value } = e.target;
// //                         setEditingEnquiry(prev => ({ ...prev, [name]: value }));
// //                     }}
// //                     handleAddOnToggle={handleAddOnToggle}
// //                     handleAddOnQuantity={handleAddOnQuantity}
// //                     handleDishSelect={handleDishSelect}
// //                     handleSubmit={async (e) => {
// //                         e.preventDefault();
// //                         alert('Edit functionality - Update API coming soon');
// //                         setShowEditModal(false);
// //                     }}
// //                     resetForm={() => { setShowEditModal(false); }}
// //                     setShowModal={setShowEditModal}
// //                     submitting={submitting}
// //                     getMinDate={getMinDate}
// //                     getMaxDate={getMaxDate}
// //                     ENUMS={ENUMS}
// //                     title="Edit Enquiry"
// //                     submitLabel="Update Enquiry"
// //                     isEdit={true}
// //                 />
// //             )}

// //             <style>{`
// //                 .stat-total { background: #e8f0fe; }
// //                 .stat-pending { background: #fff3cd; }
// //                 .stat-quoted { background: #cce5ff; }
// //                 .stat-approved { background: #d4edda; }
// //                 @keyframes spin { to { transform: rotate(360deg); } }
// //             `}</style>
// //         </div>
// //     );
// // };

// // // ─── Enquiry Modal Component ──────────────────────────────────

// // const EnquiryModal = ({
// //     formData,
// //     setFormData,
// //     addOns,
// //     setAddOns,
// //     dishes,
// //     selectedDishIds,
// //     setSelectedDishIds,
// //     handleInputChange,
// //     handleAddOnToggle,
// //     handleAddOnQuantity,
// //     handleDishSelect,
// //     handleSubmit,
// //     resetForm,
// //     setShowModal,
// //     submitting,
// //     getMinDate,
// //     getMaxDate,
// //     ENUMS,
// //     title,
// //     submitLabel,
// //     isEdit = false
// // }) => {
// //     // Filter dishes to show only those with parentId !== null (sub-dishes)
// //     const availableDishes = dishes.filter(d => d.parentId !== null && d.parentId !== undefined);

// //     return (
// //         <div style={modalOverlayStyle} onClick={() => setShowModal(false)}>
// //             <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
// //                 <div style={modalHeaderStyle}>
// //                     <h3 style={modalTitleStyle}>{title}</h3>
// //                     <button onClick={() => setShowModal(false)} style={modalCloseStyle}>
// //                         <FaTimes />
// //                     </button>
// //                 </div>

// //                 <form onSubmit={handleSubmit} style={modalBodyStyle}>
// //                     {/* Source */}
// //                     <div style={formRowStyle}>
// //                         <div style={formGroupStyle}>
// //                             <label style={labelStyle}>Source *</label>
// //                             <select
// //                                 name="source"
// //                                 value={formData.source || 'APP'}
// //                                 onChange={handleInputChange}
// //                                 style={selectStyle}
// //                                 required
// //                             >
// //                                 {ENUMS.source.map(s => (
// //                                     <option key={s} value={s}>{s.replace('_', ' ')}</option>
// //                                 ))}
// //                             </select>
// //                         </div>
// //                         <div style={formGroupStyle}>
// //                             <label style={labelStyle}>Source By</label>
// //                             <input
// //                                 name="sourceBy"
// //                                 value={formData.sourceBy || ''}
// //                                 onChange={handleInputChange}
// //                                 style={inputStyle}
// //                                 placeholder="Source reference"
// //                             />
// //                         </div>
// //                     </div>

// //                     {/* Customer Details */}
// //                     <div style={sectionStyle}>
// //                         <div style={sectionTitleStyle}>
// //                             <FaUser size={16} />
// //                             <span>Customer Details</span>
// //                         </div>
// //                         <div style={formRowStyle}>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Full Name *</label>
// //                                 <input
// //                                     name="fullName"
// //                                     value={formData.fullName || ''}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                     required
// //                                 />
// //                             </div>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Email *</label>
// //                                 <input
// //                                     name="email"
// //                                     type="email"
// //                                     value={formData.email || ''}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                     required
// //                                 />
// //                             </div>
// //                         </div>
// //                         <div style={formRowStyle}>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Phone Number *</label>
// //                                 <input
// //                                     name="phoneNumber"
// //                                     value={formData.phoneNumber || ''}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                     required
// //                                 />
// //                             </div>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Company Name</label>
// //                                 <input
// //                                     name="companyName"
// //                                     value={formData.companyName || ''}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                 />
// //                             </div>
// //                         </div>
// //                     </div>

// //                     {/* Event Details */}
// //                     <div style={sectionStyle}>
// //                         <div style={sectionTitleStyle}>
// //                             <FaCalendarAlt size={16} />
// //                             <span>Event Details</span>
// //                         </div>
// //                         <div style={formRowStyle}>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Event *</label>
// //                                 <select
// //                                     name="event"
// //                                     value={formData.event || 'EVENT'}
// //                                     onChange={handleInputChange}
// //                                     style={selectStyle}
// //                                     required
// //                                 >
// //                                     {ENUMS.event.map(e => (
// //                                         <option key={e} value={e}>{e}</option>
// //                                     ))}
// //                                 </select>
// //                             </div>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Event Type *</label>
// //                                 <select
// //                                     name="eventType"
// //                                     value={formData.eventType || 'WEDDING'}
// //                                     onChange={handleInputChange}
// //                                     style={selectStyle}
// //                                     required
// //                                 >
// //                                     {ENUMS.eventType.map(e => (
// //                                         <option key={e} value={e}>{e}</option>
// //                                     ))}
// //                                 </select>
// //                             </div>
// //                         </div>

// //                         {formData.event === 'EVENT' ? (
// //                             <div style={formRowStyle}>
// //                                 <div style={formGroupStyle}>
// //                                     <label style={labelStyle}>Event Date *</label>
// //                                     <input
// //                                         name="eventDate"
// //                                         type="date"
// //                                         value={formData.eventDate || ''}
// //                                         onChange={handleInputChange}
// //                                         style={inputStyle}
// //                                         min={getMinDate()}
// //                                         max={getMaxDate()}
// //                                         required
// //                                     />
// //                                 </div>
// //                                 <div style={formGroupStyle}>
// //                                     <label style={labelStyle}>Event Time</label>
// //                                     <input
// //                                         name="eventTime"
// //                                         type="time"
// //                                         value={formData.eventTime || ''}
// //                                         onChange={handleInputChange}
// //                                         style={inputStyle}
// //                                     />
// //                                 </div>
// //                             </div>
// //                         ) : (
// //                             <div style={formRowStyle}>
// //                                 <div style={formGroupStyle}>
// //                                     <label style={labelStyle}>From Date *</label>
// //                                     <input
// //                                         name="fromDate"
// //                                         type="date"
// //                                         value={formData.fromDate || ''}
// //                                         onChange={handleInputChange}
// //                                         style={inputStyle}
// //                                         min={getMinDate()}
// //                                         max={getMaxDate()}
// //                                         required
// //                                     />
// //                                 </div>
// //                                 <div style={formGroupStyle}>
// //                                     <label style={labelStyle}>To Date *</label>
// //                                     <input
// //                                         name="toDate"
// //                                         type="date"
// //                                         value={formData.toDate || ''}
// //                                         onChange={handleInputChange}
// //                                         style={inputStyle}
// //                                         min={getMinDate()}
// //                                         max={getMaxDate()}
// //                                         required
// //                                     />
// //                                 </div>
// //                             </div>
// //                         )}
// //                     </div>

// //                     {/* Venue Details */}
// //                     <div style={sectionStyle}>
// //                         <div style={sectionTitleStyle}>
// //                             <FaMapMarkerAlt size={16} />
// //                             <span>Venue / Address</span>
// //                         </div>
// //                         <div style={formGroupStyle}>
// //                             <label style={labelStyle}>Full Address *</label>
// //                             <textarea
// //                                 name="fullAddress"
// //                                 value={formData.fullAddress || ''}
// //                                 onChange={handleInputChange}
// //                                 style={textareaStyle}
// //                                 rows="2"
// //                                 required
// //                             />
// //                         </div>
// //                         <div style={formRowStyle}>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>City *</label>
// //                                 <input
// //                                     name="city"
// //                                     value={formData.city || ''}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                     required
// //                                 />
// //                             </div>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>State *</label>
// //                                 <input
// //                                     name="state"
// //                                     value={formData.state || ''}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                     required
// //                                 />
// //                             </div>
// //                         </div>
// //                         <div style={formRowStyle}>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Country</label>
// //                                 <input
// //                                     name="country"
// //                                     value={formData.country || 'India'}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                 />
// //                             </div>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Pincode *</label>
// //                                 <input
// //                                     name="pincode"
// //                                     type="number"
// //                                     value={formData.pincode || ''}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                     required
// //                                 />
// //                             </div>
// //                         </div>
// //                     </div>

// //                     {/* Plate Count & Budget */}
// //                     <div style={sectionStyle}>
// //                         <div style={sectionTitleStyle}>
// //                             <FaUtensils size={16} />
// //                             <span>Plate Count & Budget</span>
// //                         </div>
// //                         <div style={formRowStyle}>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Veg Plates</label>
// //                                 <input
// //                                     name="vegPlates"
// //                                     type="number"
// //                                     value={formData.vegPlates || 0}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                     min="0"
// //                                 />
// //                             </div>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Non-Veg Plates</label>
// //                                 <input
// //                                     name="nonVegPlates"
// //                                     type="number"
// //                                     value={formData.nonVegPlates || 0}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                     min="0"
// //                                 />
// //                             </div>
// //                         </div>
// //                         <div style={formRowStyle}>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Mixed Plates</label>
// //                                 <input
// //                                     name="mixedPlates"
// //                                     type="number"
// //                                     value={formData.mixedPlates || 0}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                     min="0"
// //                                 />
// //                             </div>
// //                             <div style={formGroupStyle}>
// //                                 <label style={labelStyle}>Budget (₹)</label>
// //                                 <input
// //                                     name="budget"
// //                                     type="number"
// //                                     value={formData.budget || 0}
// //                                     onChange={handleInputChange}
// //                                     style={inputStyle}
// //                                     min="0"
// //                                 />
// //                             </div>
// //                         </div>
// //                     </div>

// //                     {/* Add-ons Section */}
// //                     <div style={sectionStyle}>
// //                         <div style={sectionTitleStyle}>
// //                             <FaCheckCircle size={16} />
// //                             <span>Add-ons</span>
// //                         </div>
// //                         {addOns.map((addon, index) => (
// //                             <div key={index} style={addonRowStyle}>
// //                                 <label style={checkboxLabelStyle}>
// //                                     <input
// //                                         type="checkbox"
// //                                         checked={addon.selected}
// //                                         onChange={() => handleAddOnToggle(index)}
// //                                     />
// //                                     <span style={{ fontWeight: 500 }}>{addon.label}</span>
// //                                 </label>
// //                                 {addon.selected && (
// //                                     <input
// //                                         type="number"
// //                                         value={addon.quantity}
// //                                         onChange={(e) => handleAddOnQuantity(index, e.target.value)}
// //                                         style={addonQuantityStyle}
// //                                         min="1"
// //                                         placeholder="Qty"
// //                                     />
// //                                 )}
// //                             </div>
// //                         ))}
// //                     </div>

// //                     {/* Dishes Section */}
// //                     <div style={sectionStyle}>
// //                         <div style={sectionTitleStyle}>
// //                             <FaUtensils size={16} />
// //                             <span>Select Dishes</span>
// //                         </div>
// //                         <div style={dishesGridStyle}>
// //                             {availableDishes.length === 0 ? (
// //                                 <div style={{ color: '#999', fontSize: '13px' }}>No dishes available</div>
// //                             ) : (
// //                                 availableDishes.map(dish => (
// //                                     <label key={dish.dishId} style={dishCheckboxStyle}>
// //                                         <input
// //                                             type="checkbox"
// //                                             checked={selectedDishIds.includes(dish.dishId)}
// //                                             onChange={() => handleDishSelect(dish.dishId)}
// //                                         />
// //                                         <span>{dish.dishName}</span>
// //                                         <span style={{ fontSize: '11px', color: '#888' }}>₹{dish.effectivePrice || dish.dishPrice}</span>
// //                                     </label>
// //                                 ))
// //                             )}
// //                         </div>
// //                     </div>

// //                     {/* Additional Requests */}
// //                     <div style={sectionStyle}>
// //                         <div style={sectionTitleStyle}>
// //                             <FaEdit size={16} />
// //                             <span>Additional Requests</span>
// //                         </div>
// //                         <textarea
// //                             name="additionalRequests"
// //                             value={formData.additionalRequests || ''}
// //                             onChange={handleInputChange}
// //                             style={textareaStyle}
// //                             rows="2"
// //                             placeholder="Any special requests..."
// //                         />
// //                     </div>

// //                     {/* GST Requirement */}
// //                     <div style={formGroupStyle}>
// //                         <label style={labelStyle}>GST Requirement</label>
// //                         <input
// //                             name="gstRequirement"
// //                             value={formData.gstRequirement || ''}
// //                             onChange={handleInputChange}
// //                             style={inputStyle}
// //                             placeholder="GST details if applicable"
// //                         />
// //                     </div>

// //                     {/* Form Actions */}
// //                     <div style={formActionStyle}>
// //                         <button
// //                             type="button"
// //                             onClick={() => { resetForm(); setShowModal(false); }}
// //                             style={cancelButtonStyle}
// //                         >
// //                             Cancel
// //                         </button>
// //                         <button type="submit" style={submitButtonStyle} disabled={submitting}>
// //                             {submitting ? (
// //                                 <>
// //                                     <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
// //                                     {isEdit ? 'Updating...' : 'Creating...'}
// //                                 </>
// //                             ) : (
// //                                 <>
// //                                     <FaPlus size={14} />
// //                                     {submitLabel}
// //                                 </>
// //                             )}
// //                         </button>
// //                     </div>
// //                 </form>
// //             </div>
// //         </div>
// //     );
// // };

// // // ─── Styles ──────────────────────────────────────────────────────

// // const containerStyle = {
// //     padding: '20px',
// // };

// // const headerStyle = {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     marginBottom: '20px',
// //     flexWrap: 'wrap',
// //     gap: '12px',
// // };

// // const headerLeftStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '12px',
// // };

// // const titleStyle = {
// //     fontSize: '24px',
// //     fontWeight: 700,
// //     color: '#333',
// //     margin: 0,
// // };

// // const countStyle = {
// //     fontSize: '14px',
// //     color: '#888',
// //     background: '#f0f0f0',
// //     padding: '4px 12px',
// //     borderRadius: '20px',
// // };

// // const createButtonStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     padding: '10px 20px',
// //     background: '#e66d33',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '10px',
// //     fontWeight: 600,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const statsContainerStyle = {
// //     display: 'grid',
// //     gridTemplateColumns: 'repeat(4, 1fr)',
// //     gap: '16px',
// //     marginBottom: '20px',
// // };

// // const statCardStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '12px',
// //     background: '#fff',
// //     padding: '16px 20px',
// //     borderRadius: '12px',
// //     boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
// //     border: '1px solid #f0ebe6',
// // };

// // const statIconStyle = {
// //     fontSize: '28px',
// //     width: '48px',
// //     height: '48px',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     borderRadius: '12px',
// // };

// // const statNumberStyle = {
// //     fontSize: '22px',
// //     fontWeight: 700,
// //     color: '#333',
// // };

// // const statLabelStyle = {
// //     fontSize: '13px',
// //     color: '#888',
// // };

// // const searchFilterContainerStyle = {
// //     display: 'flex',
// //     gap: '12px',
// //     marginBottom: '20px',
// //     flexWrap: 'wrap',
// //     alignItems: 'center',
// // };

// // const searchContainerStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     flex: 1,
// //     background: '#fff',
// //     border: '1px solid #e0d6ce',
// //     borderRadius: '10px',
// //     padding: '0 14px',
// // };

// // const searchIconStyle = {
// //     color: '#999',
// //     marginRight: '10px',
// // };

// // const searchInputStyle = {
// //     flex: 1,
// //     padding: '12px 0',
// //     border: 'none',
// //     outline: 'none',
// //     fontSize: '14px',
// //     background: 'transparent',
// // };

// // const filterContainerStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     background: '#fff',
// //     border: '1px solid #e0d6ce',
// //     borderRadius: '10px',
// //     padding: '0 14px',
// // };

// // const filterIconStyle = {
// //     color: '#999',
// //     marginRight: '10px',
// // };

// // const filterSelectStyle = {
// //     padding: '12px 8px',
// //     border: 'none',
// //     outline: 'none',
// //     fontSize: '14px',
// //     background: 'transparent',
// //     cursor: 'pointer',
// // };

// // const refreshButtonStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '6px',
// //     padding: '10px 16px',
// //     background: '#6c757d',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '10px',
// //     fontWeight: 500,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const tableCardStyle = {
// //     background: '#fff',
// //     borderRadius: '12px',
// //     boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
// //     overflow: 'hidden',
// //     border: '1px solid #f0ebe6',
// // };

// // const tableWrapperStyle = {
// //     overflowX: 'auto',
// //     padding:"10px",
// // };

// // const tableStyle = {
// //     width: '100%',
// //     borderCollapse: 'collapse',
// //     minWidth: '1100px',
// // };

// // const tableRowStyle = {
// //     borderBottom: '1px solid #f0ebe6',
// //     transition: 'background 0.2s ease',
// // };

// // const tableCellStyle = {
// //     padding: '12px 14px',
// //     fontSize: '13px',
// //     color: '#333',
// // };

// // const emptyStateStyle = {
// //     padding: '40px',
// //     textAlign: 'center',
// //     color: '#999',
// // };

// // const loadingStyle = {
// //     padding: '40px',
// //     textAlign: 'center',
// //     color: '#666',
// //     '& p': {
// //         marginTop: '12px',
// //     },
// // };

// // const platesBadgeStyle = {
// //     display: 'inline-block',
// //     padding: '2px 10px',
// //     background: 'rgba(230, 126, 34, 0.1)',
// //     borderRadius: '12px',
// //     fontSize: '12px',
// //     fontWeight: 600,
// //     color: '#e66d33',
// // };

// // const pendingBadgeStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '2px 10px',
// //     background: '#fff3cd',
// //     borderRadius: '12px',
// //     fontSize: '11px',
// //     fontWeight: 600,
// //     color: '#856404',
// // };

// // const quotedBadgeStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '2px 10px',
// //     background: '#cce5ff',
// //     borderRadius: '12px',
// //     fontSize: '11px',
// //     fontWeight: 600,
// //     color: '#004085',
// // };

// // const approvedBadgeStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '2px 10px',
// //     background: '#d4edda',
// //     borderRadius: '12px',
// //     fontSize: '11px',
// //     fontWeight: 600,
// //     color: '#155724',
// // };

// // const rejectedBadgeStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '2px 10px',
// //     background: '#f8d7da',
// //     borderRadius: '12px',
// //     fontSize: '11px',
// //     fontWeight: 600,
// //     color: '#721c24',
// // };

// // const actionGroupStyle = {
// //     display: 'flex',
// //     gap: '6px',
// //     justifyContent: 'center',
// // };

// // const viewButtonStyle = {
// //     padding: '6px 10px',
// //     background: 'rgba(23, 162, 184, 0.1)',
// //     color: '#17a2b8',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const editButtonStyle = {
// //     padding: '6px 10px',
// //     background: 'rgba(40, 167, 69, 0.1)',
// //     color: '#28a745',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const deleteButtonStyle = {
// //     padding: '6px 10px',
// //     background: 'rgba(220, 53, 69, 0.1)',
// //     color: '#dc3545',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // // ─── Modal Styles ──────────────────────────────────────────────

// // const modalOverlayStyle = {
// //     position: 'fixed',
// //     top: 0,
// //     left: 0,
// //     right: 0,
// //     bottom: 0,
// //     background: 'rgba(0,0,0,0.5)',
// //     backdropFilter: 'blur(4px)',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     zIndex: 9999,
// //     padding: '20px',
// // };

// // const modalStyle = {
// //     background: '#fff',
// //     borderRadius: '16px',
// //     width: '100%',
// //     maxWidth: '750px',
// //     maxHeight: '90vh',
// //     overflow: 'auto',
// //     boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
// // };

// // const modalHeaderStyle = {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     padding: '20px 24px',
// //     borderBottom: '1px solid #f0ebe6',
// //     position: 'sticky',
// //     top: 0,
// //     background: '#fff',
// //     zIndex: 1,
// // };

// // const modalTitleStyle = {
// //     margin: 0,
// //     fontSize: '18px',
// //     fontWeight: 700,
// //     color: '#333',
// // };

// // const modalCloseStyle = {
// //     background: 'none',
// //     border: 'none',
// //     fontSize: '20px',
// //     cursor: 'pointer',
// //     color: '#999',
// //     padding: '4px 8px',
// // };

// // const modalBodyStyle = {
// //     padding: '24px',
// // };

// // const sectionStyle = {
// //     marginBottom: '20px',
// //     paddingBottom: '20px',
// //     borderBottom: '1px solid #f0ebe6',
// // };

// // const sectionTitleStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     fontSize: '15px',
// //     fontWeight: 600,
// //     color: '#555',
// //     marginBottom: '12px',
// // };

// // const formRowStyle = {
// //     display: 'grid',
// //     gridTemplateColumns: '1fr 1fr',
// //     gap: '12px',
// // };

// // const formGroupStyle = {
// //     display: 'flex',
// //     flexDirection: 'column',
// //     gap: '4px',
// // };

// // const labelStyle = {
// //     fontSize: '13px',
// //     fontWeight: 500,
// //     color: '#555',
// // };

// // const inputStyle = {
// //     padding: '10px 12px',
// //     border: '1px solid #e0d6ce',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     outline: 'none',
// //     transition: 'border-color 0.2s ease',
// // };

// // const selectStyle = {
// //     ...inputStyle,
// //     background: '#fff',
// //     appearance: 'auto',
// // };

// // const textareaStyle = {
// //     ...inputStyle,
// //     resize: 'vertical',
// //     fontFamily: 'inherit',
// //     width: '100%',
// // };

// // const formActionStyle = {
// //     display: 'flex',
// //     gap: '12px',
// //     justifyContent: 'flex-end',
// //     marginTop: '8px',
// // };

// // const cancelButtonStyle = {
// //     padding: '10px 24px',
// //     background: '#f0f0f0',
// //     color: '#666',
// //     border: 'none',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     fontWeight: 500,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const submitButtonStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     padding: '10px 24px',
// //     background: '#e66d33',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     fontWeight: 600,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // // ─── Add-ons Styles ─────────────────────────────────────────────

// // const addonRowStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'space-between',
// //     padding: '8px 0',
// //     borderBottom: '1px solid #f5f5f5',
// // };

// // const checkboxLabelStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     cursor: 'pointer',
// //     fontSize: '14px',
// // };

// // const addonQuantityStyle = {
// //     width: '70px',
// //     padding: '4px 8px',
// //     border: '1px solid #e0d6ce',
// //     borderRadius: '6px',
// //     fontSize: '13px',
// //     textAlign: 'center',
// // };

// // // ─── Dishes Styles ──────────────────────────────────────────────

// // const dishesGridStyle = {
// //     display: 'grid',
// //     gridTemplateColumns: 'repeat(2, 1fr)',
// //     gap: '8px',
// //     maxHeight: '150px',
// //     overflowY: 'auto',
// //     padding: '4px',
// // };

// // const dishCheckboxStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     padding: '6px 10px',
// //     border: '1px solid #f0ebe6',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     fontSize: '13px',
// //     transition: 'all 0.2s ease',
// // };

// // export default SalesEnquiry;







// // SalesEnquiry.jsx
// import React, { useState, useEffect } from 'react';
// import { 
//     FaPlus, FaEye, FaEdit, FaTrash, FaTimes, 
//     FaUser, FaEnvelope, FaPhone, FaBuilding, 
//     FaMapMarkerAlt, FaCalendarAlt, FaUtensils,
//     FaCheckCircle, FaSearch, FaFilter, FaClock,
//     FaSpinner, FaSync, FaChevronDown, FaUsers,
//     FaClipboardList, FaChartBar
// } from 'react-icons/fa';
// import { 
//     getAllDishes, 
//     createEnquiry, 
//     getAllEnquiries, 
//     deleteEnquiry,
//     ENUMS 
// } from '../../Servicefile/salesService';

// const SalesEnquiry = () => {
//     const [showCreateModal, setShowCreateModal] = useState(false);
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [filterType, setFilterType] = useState('all');
//     const [loading, setLoading] = useState(false);
//     const [submitting, setSubmitting] = useState(false);
//     const [enquiries, setEnquiries] = useState([]);
//     const [dishes, setDishes] = useState([]);
//     const [editingEnquiry, setEditingEnquiry] = useState(null);

//     const [formData, setFormData] = useState({
//         source: 'APP',
//         sourceBy: '',
//         fullName: '',
//         email: '',
//         phoneNumber: '',
//         event: 'EVENT',
//         eventType: 'WEDDING',
//         eventDate: '',
//         eventTime: '',
//         fromDate: '',
//         toDate: '',
//         fullAddress: '',
//         city: '',
//         state: '',
//         country: 'India',
//         companyName: '',
//         vegPlates: 0,
//         nonVegPlates: 0,
//         mixedPlates: 0,
//         additionalRequests: '',
//         adminPermision: false,
//         leadStatus: 'PENDING',
//         budget: 0,
//         latitude: 0,
//         longitude: 0,
//         pincode: '',
//         gstRequirement: '',
//         dishId: [],
//         addOns: []
//     });

//     const addOnOptions = [
//         { addOnType: 'SERVICE_BOYS', label: 'Service Boys', selected: false, quantity: 0 },
//         { addOnType: 'PAPER_PLATES', label: 'Paper Plates', selected: false, quantity: 0 },
//         { addOnType: 'WATER_BOTTLES', label: 'Water Bottles', selected: false, quantity: 0 },
//         { addOnType: 'DISPOSABLE_CUPS', label: 'Disposable Cups', selected: false, quantity: 0 },
//         { addOnType: 'TISSUE_PAPER', label: 'Tissue Paper', selected: false, quantity: 0 }
//     ];

//     const [addOns, setAddOns] = useState(addOnOptions);
//     const [selectedDishIds, setSelectedDishIds] = useState([]);

//     useEffect(() => {
//         fetchDishes();
//         fetchEnquiries();
//     }, []);

//     const fetchDishes = async () => {
//         try {
//             const data = await getAllDishes();
//             setDishes(data || []);
//         } catch (error) {
//             console.error('Error fetching dishes:', error);
//         }
//     };

//     const fetchEnquiries = async () => {
//         setLoading(true);
//         try {
//             const data = await getAllEnquiries();
//             setEnquiries(data || []);
//         } catch (error) {
//             console.error('Error fetching enquiries:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({ ...prev, [name]: value }));
//     };

//     const handleAddOnToggle = (index) => {
//         const updated = [...addOns];
//         updated[index].selected = !updated[index].selected;
//         if (!updated[index].selected) {
//             updated[index].quantity = 0;
//         }
//         setAddOns(updated);
//     };

//     const handleAddOnQuantity = (index, value) => {
//         const updated = [...addOns];
//         updated[index].quantity = parseInt(value) || 0;
//         setAddOns(updated);
//     };

//     const handleDishSelect = (dishId) => {
//         setSelectedDishIds(prev => {
//             if (prev.includes(dishId)) {
//                 return prev.filter(id => id !== dishId);
//             } else {
//                 return [...prev, dishId];
//             }
//         });
//     };

//     const getMinDate = () => {
//         const date = new Date();
//         date.setDate(date.getDate() + 2);
//         return date.toISOString().split('T')[0];
//     };

//     const getMaxDate = () => {
//         const date = new Date();
//         date.setFullYear(date.getFullYear() + 3);
//         return date.toISOString().split('T')[0];
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!formData.fullName) {
//             alert('Please enter full name');
//             return;
//         }
//         if (!formData.email) {
//             alert('Please enter email');
//             return;
//         }
//         if (!formData.phoneNumber) {
//             alert('Please enter phone number');
//             return;
//         }

//         if (formData.event === 'EVENT') {
//             if (!formData.eventDate) {
//                 alert('Please select event date');
//                 return;
//             }
//         } else if (formData.event === 'DAILY') {
//             if (!formData.fromDate || !formData.toDate) {
//                 alert('Please select from and to dates');
//                 return;
//             }
//         }

//         const selectedAddOns = addOns
//             .filter(a => a.selected)
//             .map(a => ({
//                 addOnType: a.addOnType,
//                 quantity: a.quantity || 1,
//                 selected: true
//             }));

//         const requestBody = {
//             ...formData,
//             eventDate: formData.eventDate ? formatDateForAPI(formData.eventDate) : '',
//             fromDate: formData.fromDate ? formatDateForAPI(formData.fromDate) : '',
//             toDate: formData.toDate ? formatDateForAPI(formData.toDate) : '',
//             eventTime: formData.eventTime || '',
//             addOns: selectedAddOns,
//             dishId: selectedDishIds,
//             pincode: parseInt(formData.pincode) || 0,
//             budget: parseFloat(formData.budget) || 0,
//             vegPlates: parseInt(formData.vegPlates) || 0,
//             nonVegPlates: parseInt(formData.nonVegPlates) || 0,
//             mixedPlates: parseInt(formData.mixedPlates) || 0
//         };

//         setSubmitting(true);
//         try {
//             await createEnquiry(requestBody);
//             alert('Enquiry created successfully!');
//             setShowCreateModal(false);
//             resetForm();
//             fetchEnquiries();
//         } catch (error) {
//             console.error('Error creating enquiry:', error);
//             alert(error.response?.data?.message || 'Failed to create enquiry');
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const resetForm = () => {
//         setFormData({
//             source: 'APP',
//             sourceBy: '',
//             fullName: '',
//             email: '',
//             phoneNumber: '',
//             event: 'EVENT',
//             eventType: 'WEDDING',
//             eventDate: '',
//             eventTime: '',
//             fromDate: '',
//             toDate: '',
//             fullAddress: '',
//             city: '',
//             state: '',
//             country: 'India',
//             companyName: '',
//             vegPlates: 0,
//             nonVegPlates: 0,
//             mixedPlates: 0,
//             additionalRequests: '',
//             adminPermision: false,
//             leadStatus: 'PENDING',
//             budget: 0,
//             latitude: 0,
//             longitude: 0,
//             pincode: '',
//             gstRequirement: '',
//             dishId: [],
//             addOns: []
//         });
//         setAddOns(addOnOptions);
//         setSelectedDishIds([]);
//         setEditingEnquiry(null);
//     };

//     const handleDelete = async (id) => {
//         if (!window.confirm('Are you sure you want to delete this enquiry?')) return;

//         try {
//             await deleteEnquiry(id);
//             alert('Enquiry deleted successfully!');
//             fetchEnquiries();
//         } catch (error) {
//             console.error('Error deleting enquiry:', error);
//             alert('Failed to delete enquiry');
//         }
//     };

//     const getStatusBadge = (status) => {
//         const statusMap = {
//             'PENDING': { bg: '#FEF3C7', color: '#92400E', label: 'Pending', icon: <FaClock size={10} /> },
//             'IN_PROGRESS': { bg: '#DBEAFE', color: '#1E40AF', label: 'In Progress', icon: <FaSync size={10} /> },
//             'QUOTED': { bg: '#E0E7FF', color: '#3730A3', label: 'Quoted', icon: <FaCheckCircle size={10} /> },
//             'APPROVED': { bg: '#D1FAE5', color: '#065F46', label: 'Approved', icon: <FaCheckCircle size={10} /> },
//             'REJECTED': { bg: '#FEE2E2', color: '#991B1B', label: 'Rejected', icon: <FaTimes size={10} /> },
//             'CLOSED': { bg: '#F3F4F6', color: '#4B5563', label: 'Closed', icon: <FaTimes size={10} /> }
//         };
//         const statusInfo = statusMap[status] || statusMap['PENDING'];
//         return (
//             <span style={{
//                 ...badgeStyle,
//                 background: statusInfo.bg,
//                 color: statusInfo.color
//             }}>
//                 {statusInfo.icon} {statusInfo.label}
//             </span>
//         );
//     };

//     const filteredEnquiries = enquiries.filter(e => {
//         const matchesSearch = 
//             (e.fullName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (e.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (e.companyName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (e.city || '').toLowerCase().includes(searchTerm.toLowerCase());

//         const matchesFilter = filterType === 'all' || e.leadStatus === filterType;

//         return matchesSearch && matchesFilter;
//     });

//     const getStatusCount = (status) => {
//         return enquiries.filter(e => e.leadStatus === status).length;
//     };

//     const formatDate = (dateStr) => {
//         if (!dateStr) return '-';
//         try {
//             const date = new Date(dateStr);
//             return date.toLocaleDateString('en-IN', {
//                 day: '2-digit',
//                 month: 'short',
//                 year: 'numeric'
//             });
//         } catch {
//             return dateStr;
//         }
//     };

//     const formatDateForAPI = (dateStr) => {
//         if (!dateStr) return '';
//         const parts = dateStr.split('-');
//         return `${parts[2]}-${parts[1]}-${parts[0]}`;
//     };

//     const getTotalPlates = (enquiry) => {
//         return (enquiry.vegPlates || 0) + (enquiry.nonVegPlates || 0) + (enquiry.mixedPlates || 0);
//     };

//     return (
//         <div style={containerStyle}>
//             {/* Header */}
//             <div style={headerStyle}>
//                 <div style={headerLeftStyle}>
//                     <div style={headerIconStyle}>
//                         <FaClipboardList size={22} />
//                     </div>
//                     <div>
//                         <h2 style={titleStyle}>Sales Enquiries</h2>
//                         <p style={subtitleStyle}>Manage all customer enquiries in one place</p>
//                     </div>
//                 </div>
//                 <button
//                     onClick={() => { resetForm(); setShowCreateModal(true); }}
//                     style={createButtonStyle}
//                     onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
//                     onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//                 >
//                     <FaPlus size={14} />
//                     New Enquiry
//                 </button>
//             </div>

//             {/* Stats Cards */}
//             <div style={statsContainerStyle}>
//                 <div style={statCardStyle}>
//                     <div style={{...statIconWrapperStyle, background: '#EEF2FF'}}>
//                         <FaClipboardList style={{color: '#4F46E5'}} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{enquiries.length}</div>
//                         <div style={statLabelStyle}>Total Enquiries</div>
//                     </div>
//                 </div>
//                 <div style={statCardStyle}>
//                     <div style={{...statIconWrapperStyle, background: '#FEF3C7'}}>
//                         <FaClock style={{color: '#D97706'}} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{getStatusCount('PENDING')}</div>
//                         <div style={statLabelStyle}>Pending</div>
//                     </div>
//                 </div>
//                 <div style={statCardStyle}>
//                     <div style={{...statIconWrapperStyle, background: '#E0E7FF'}}>
//                         <FaCheckCircle style={{color: '#4F46E5'}} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{getStatusCount('QUOTED')}</div>
//                         <div style={statLabelStyle}>Quoted</div>
//                     </div>
//                 </div>
//                 <div style={statCardStyle}>
//                     <div style={{...statIconWrapperStyle, background: '#D1FAE5'}}>
//                         <FaCheckCircle style={{color: '#059669'}} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{getStatusCount('APPROVED')}</div>
//                         <div style={statLabelStyle}>Approved</div>
//                     </div>
//                 </div>
//             </div>

//             {/* Search and Filter */}
//             <div style={searchFilterContainerStyle}>
//                 <div style={searchContainerStyle}>
//                     <FaSearch style={searchIconStyle} />
//                     <input
//                         type="text"
//                         placeholder="Search by name, email, city..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         style={searchInputStyle}
//                     />
//                 </div>
//                 <div style={filterContainerStyle}>
//                     <FaFilter style={filterIconStyle} />
//                     <select
//                         value={filterType}
//                         onChange={(e) => setFilterType(e.target.value)}
//                         style={filterSelectStyle}
//                     >
//                         <option value="all">All Status</option>
//                         <option value="PENDING">Pending</option>
//                         <option value="QUOTED">Quoted</option>
//                         <option value="APPROVED">Approved</option>
//                         <option value="REJECTED">Rejected</option>
//                         <option value="CLOSED">Closed</option>
//                     </select>
//                     <FaChevronDown style={{color: '#9CA3AF', fontSize: '10px', marginLeft: '4px'}} />
//                 </div>
//                 <button onClick={fetchEnquiries} style={refreshButtonStyle}>
//                     <FaSync size={13} />
//                     Refresh
//                 </button>
//             </div>

//             {/* Table */}
//             <div style={tableCardStyle}>
//                 {loading ? (
//                     <div style={loadingStyle}>
//                         <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={32} color="#4F46E5" />
//                         <p>Loading enquiries...</p>
//                     </div>
//                 ) : (
//                     <div style={tableWrapperStyle}>
//                         <table style={tableStyle}>
//                             <thead>
//                                 <tr>
//                                     <th style={{...thStyle, width: '5%', textAlign: 'center'}}>S.No</th>
//                                     <th style={{...thStyle, width: '14%', textAlign: 'left'}}>Customer</th>
//                                     <th style={{...thStyle, width: '10%', textAlign: 'center'}}>Event</th>
//                                     <th style={{...thStyle, width: '10%', textAlign: 'center'}}>Date</th>
//                                     <th style={{...thStyle, width: '10%', textAlign: 'center'}}>City</th>
//                                     <th style={{...thStyle, width: '8%', textAlign: 'center'}}>Plates</th>
//                                     <th style={{...thStyle, width: '10%', textAlign: 'center'}}>Budget</th>
//                                     <th style={{...thStyle, width: '10%', textAlign: 'center'}}>Status</th>
//                                     <th style={{...thStyle, width: '10%', textAlign: 'center'}}>Created</th>
//                                     <th style={{...thStyle, width: '13%', textAlign: 'center'}}>Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filteredEnquiries.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="10" style={emptyStateStyle}>
//                                             <div style={emptyStateContentStyle}>
//                                                 <FaClipboardList size={40} color="#D1D5DB" />
//                                                 <p>No enquiries found</p>
//                                                 <span style={{fontSize: '13px', color: '#9CA3AF'}}>
//                                                     Try adjusting your search or filter
//                                                 </span>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ) : (
//                                     filteredEnquiries.map((enquiry, index) => (
//                                         <tr key={enquiry.id || enquiry.enquiryId || index} style={tableRowStyle}>
//                                             <td style={{...tdStyle, textAlign: 'center', fontWeight: 500, color: '#9CA3AF'}}>
//                                                 {index + 1}
//                                             </td>
//                                             <td style={{...tdStyle, textAlign: 'left'}}>
//                                                 <div style={customerCellStyle}>
//                                                     <div style={avatarStyle}>
//                                                         {(enquiry.fullName || '?')[0].toUpperCase()}
//                                                     </div>
//                                                     <div>
//                                                         <div style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>
//                                                             {enquiry.fullName || '-'}
//                                                         </div>
//                                                         <div style={{ fontSize: '12px', color: '#6B7280' }}>
//                                                             {enquiry.email || '-'}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </td>
//                                             <td style={{...tdStyle, textAlign: 'center'}}>
//                                                 <span style={eventBadgeStyle}>
//                                                     {enquiry.eventType || '-'}
//                                                 </span>
//                                             </td>
//                                             <td style={{...tdStyle, textAlign: 'center', fontSize: '13px', color: '#374151'}}>
//                                                 {enquiry.event === 'EVENT' 
//                                                     ? formatDate(enquiry.eventDate) 
//                                                     : `${formatDate(enquiry.fromDate)} - ${formatDate(enquiry.toDate)}`}
//                                             </td>
//                                             <td style={{...tdStyle, textAlign: 'center'}}>
//                                                 <span style={cityBadgeStyle}>
//                                                     {enquiry.city || '-'}
//                                                 </span>
//                                             </td>
//                                             <td style={{...tdStyle, textAlign: 'center'}}>
//                                                 <span style={platesBadgeStyle}>
//                                                     {getTotalPlates(enquiry)}
//                                                 </span>
//                                             </td>
//                                             <td style={{...tdStyle, textAlign: 'center', fontWeight: 600, color: '#059669'}}>
//                                                 ₹{Number(enquiry.budget || 0).toLocaleString()}
//                                             </td>
//                                             <td style={{...tdStyle, textAlign: 'center'}}>
//                                                 {getStatusBadge(enquiry.leadStatus)}
//                                             </td>
//                                             <td style={{...tdStyle, textAlign: 'center', fontSize: '12px', color: '#6B7280'}}>
//                                                 {formatDate(enquiry.createdAt)}
//                                             </td>
//                                             <td style={{...tdStyle, textAlign: 'center'}}>
//                                                 <div style={actionGroupStyle}>
//                                                     <button
//                                                         style={editButtonStyle}
//                                                         title="Edit"
//                                                         onClick={() => {
//                                                             setEditingEnquiry(enquiry);
//                                                             setShowEditModal(true);
//                                                         }}
//                                                         onMouseEnter={(e) => e.currentTarget.style.background = '#10B981'}
//                                                         onMouseLeave={(e) => e.currentTarget.style.background = '#34D399'}
//                                                     >
//                                                         <FaEdit size={13} />
//                                                     </button>
//                                                     <button
//                                                         style={deleteButtonStyle}
//                                                         title="Delete"
//                                                         onClick={() => handleDelete(enquiry.id || enquiry.enquiryId)}
//                                                         onMouseEnter={(e) => e.currentTarget.style.background = '#EF4444'}
//                                                         onMouseLeave={(e) => e.currentTarget.style.background = '#F87171'}
//                                                     >
//                                                         <FaTrash size={13} />
//                                                     </button>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     ))
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}
//             </div>

//             {/* Create Enquiry Modal */}
//             {showCreateModal && (
//                 <EnquiryModal
//                     formData={formData}
//                     setFormData={setFormData}
//                     addOns={addOns}
//                     setAddOns={setAddOns}
//                     dishes={dishes}
//                     selectedDishIds={selectedDishIds}
//                     setSelectedDishIds={setSelectedDishIds}
//                     handleInputChange={handleInputChange}
//                     handleAddOnToggle={handleAddOnToggle}
//                     handleAddOnQuantity={handleAddOnQuantity}
//                     handleDishSelect={handleDishSelect}
//                     handleSubmit={handleSubmit}
//                     resetForm={resetForm}
//                     setShowModal={setShowCreateModal}
//                     submitting={submitting}
//                     getMinDate={getMinDate}
//                     getMaxDate={getMaxDate}
//                     ENUMS={ENUMS}
//                     title="New Enquiry"
//                     submitLabel="Create Enquiry"
//                 />
//             )}

//             {/* Edit Enquiry Modal */}
//             {showEditModal && editingEnquiry && (
//                 <EnquiryModal
//                     formData={editingEnquiry}
//                     setFormData={(data) => setEditingEnquiry(data)}
//                     addOns={addOns}
//                     setAddOns={setAddOns}
//                     dishes={dishes}
//                     selectedDishIds={selectedDishIds}
//                     setSelectedDishIds={setSelectedDishIds}
//                     handleInputChange={(e) => {
//                         const { name, value } = e.target;
//                         setEditingEnquiry(prev => ({ ...prev, [name]: value }));
//                     }}
//                     handleAddOnToggle={handleAddOnToggle}
//                     handleAddOnQuantity={handleAddOnQuantity}
//                     handleDishSelect={handleDishSelect}
//                     handleSubmit={async (e) => {
//                         e.preventDefault();
//                         alert('Edit functionality coming soon');
//                         setShowEditModal(false);
//                     }}
//                     resetForm={() => { setShowEditModal(false); }}
//                     setShowModal={setShowEditModal}
//                     submitting={submitting}
//                     getMinDate={getMinDate}
//                     getMaxDate={getMaxDate}
//                     ENUMS={ENUMS}
//                     title="Edit Enquiry"
//                     submitLabel="Update Enquiry"
//                     isEdit={true}
//                 />
//             )}

//             <style>{`
//                 @keyframes spin { to { transform: rotate(360deg); } }
//                 @keyframes fadeIn {
//                     from { opacity: 0; transform: translateY(-10px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//                 @keyframes slideUp {
//                     from { opacity: 0; transform: translateY(20px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
//             `}</style>
//         </div>
//     );
// };

// // ─── Enquiry Modal Component ──────────────────────────────────

// const EnquiryModal = ({
//     formData,
//     setFormData,
//     addOns,
//     setAddOns,
//     dishes,
//     selectedDishIds,
//     setSelectedDishIds,
//     handleInputChange,
//     handleAddOnToggle,
//     handleAddOnQuantity,
//     handleDishSelect,
//     handleSubmit,
//     resetForm,
//     setShowModal,
//     submitting,
//     getMinDate,
//     getMaxDate,
//     ENUMS,
//     title,
//     submitLabel,
//     isEdit = false
// }) => {
//     const availableDishes = dishes.filter(d => d.parentId !== null && d.parentId !== undefined);

//     return (
//         <div style={modalOverlayStyle} onClick={() => setShowModal(false)}>
//             <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
//                 <div style={modalHeaderStyle}>
//                     <div style={modalHeaderLeftStyle}>
//                         <div style={modalHeaderIconStyle}>
//                             {isEdit ? <FaEdit size={18} /> : <FaPlus size={18} />}
//                         </div>
//                         <h3 style={modalTitleStyle}>{title}</h3>
//                     </div>
//                     <button onClick={() => setShowModal(false)} style={modalCloseStyle}>
//                         <FaTimes />
//                     </button>
//                 </div>

//                 <form onSubmit={handleSubmit} style={modalBodyStyle}>
//                     {/* Source */}
//                     <div style={formRowStyle}>
//                         <div style={formGroupStyle}>
//                             <label style={labelStyle}>Source <span style={{color: '#EF4444'}}>*</span></label>
//                             <select
//                                 name="source"
//                                 value={formData.source || 'APP'}
//                                 onChange={handleInputChange}
//                                 style={selectStyle}
//                                 required
//                             >
//                                 {ENUMS.source.map(s => (
//                                     <option key={s} value={s}>{s.replace('_', ' ')}</option>
//                                 ))}
//                             </select>
//                         </div>
//                         <div style={formGroupStyle}>
//                             <label style={labelStyle}>Source By</label>
//                             <input
//                                 name="sourceBy"
//                                 value={formData.sourceBy || ''}
//                                 onChange={handleInputChange}
//                                 style={inputStyle}
//                                 placeholder="Reference"
//                             />
//                         </div>
//                     </div>

//                     {/* Customer Details */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaUser size={15} />
//                             <span>Customer Details</span>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Full Name <span style={{color: '#EF4444'}}>*</span></label>
//                                 <input
//                                     name="fullName"
//                                     value={formData.fullName || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="John Doe"
//                                     required
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Email <span style={{color: '#EF4444'}}>*</span></label>
//                                 <input
//                                     name="email"
//                                     type="email"
//                                     value={formData.email || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="john@example.com"
//                                     required
//                                 />
//                             </div>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Phone Number <span style={{color: '#EF4444'}}>*</span></label>
//                                 <input
//                                     name="phoneNumber"
//                                     value={formData.phoneNumber || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="+91 98765 43210"
//                                     required
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Company Name</label>
//                                 <input
//                                     name="companyName"
//                                     value={formData.companyName || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="Company name"
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Event Details */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaCalendarAlt size={15} />
//                             <span>Event Details</span>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Event <span style={{color: '#EF4444'}}>*</span></label>
//                                 <select
//                                     name="event"
//                                     value={formData.event || 'EVENT'}
//                                     onChange={handleInputChange}
//                                     style={selectStyle}
//                                     required
//                                 >
//                                     {ENUMS.event.map(e => (
//                                         <option key={e} value={e}>{e}</option>
//                                     ))}
//                                 </select>
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Event Type <span style={{color: '#EF4444'}}>*</span></label>
//                                 <select
//                                     name="eventType"
//                                     value={formData.eventType || 'WEDDING'}
//                                     onChange={handleInputChange}
//                                     style={selectStyle}
//                                     required
//                                 >
//                                     {ENUMS.eventType.map(e => (
//                                         <option key={e} value={e}>{e}</option>
//                                     ))}
//                                 </select>
//                             </div>
//                         </div>

//                         {formData.event === 'EVENT' ? (
//                             <div style={formRowStyle}>
//                                 <div style={formGroupStyle}>
//                                     <label style={labelStyle}>Event Date <span style={{color: '#EF4444'}}>*</span></label>
//                                     <input
//                                         name="eventDate"
//                                         type="date"
//                                         value={formData.eventDate || ''}
//                                         onChange={handleInputChange}
//                                         style={inputStyle}
//                                         min={getMinDate()}
//                                         max={getMaxDate()}
//                                         required
//                                     />
//                                 </div>
//                                 <div style={formGroupStyle}>
//                                     <label style={labelStyle}>Event Time</label>
//                                     <input
//                                         name="eventTime"
//                                         type="time"
//                                         value={formData.eventTime || ''}
//                                         onChange={handleInputChange}
//                                         style={inputStyle}
//                                     />
//                                 </div>
//                             </div>
//                         ) : (
//                             <div style={formRowStyle}>
//                                 <div style={formGroupStyle}>
//                                     <label style={labelStyle}>From Date <span style={{color: '#EF4444'}}>*</span></label>
//                                     <input
//                                         name="fromDate"
//                                         type="date"
//                                         value={formData.fromDate || ''}
//                                         onChange={handleInputChange}
//                                         style={inputStyle}
//                                         min={getMinDate()}
//                                         max={getMaxDate()}
//                                         required
//                                     />
//                                 </div>
//                                 <div style={formGroupStyle}>
//                                     <label style={labelStyle}>To Date <span style={{color: '#EF4444'}}>*</span></label>
//                                     <input
//                                         name="toDate"
//                                         type="date"
//                                         value={formData.toDate || ''}
//                                         onChange={handleInputChange}
//                                         style={inputStyle}
//                                         min={getMinDate()}
//                                         max={getMaxDate()}
//                                         required
//                                     />
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                     {/* Venue Details */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaMapMarkerAlt size={15} />
//                             <span>Venue Details</span>
//                         </div>
//                         <div style={formGroupStyle}>
//                             <label style={labelStyle}>Full Address <span style={{color: '#EF4444'}}>*</span></label>
//                             <textarea
//                                 name="fullAddress"
//                                 value={formData.fullAddress || ''}
//                                 onChange={handleInputChange}
//                                 style={textareaStyle}
//                                 rows="2"
//                                 placeholder="123 Main St, City"
//                                 required
//                             />
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>City <span style={{color: '#EF4444'}}>*</span></label>
//                                 <input
//                                     name="city"
//                                     value={formData.city || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="Mumbai"
//                                     required
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>State <span style={{color: '#EF4444'}}>*</span></label>
//                                 <input
//                                     name="state"
//                                     value={formData.state || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="Maharashtra"
//                                     required
//                                 />
//                             </div>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Country</label>
//                                 <input
//                                     name="country"
//                                     value={formData.country || 'India'}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Pincode <span style={{color: '#EF4444'}}>*</span></label>
//                                 <input
//                                     name="pincode"
//                                     type="number"
//                                     value={formData.pincode || ''}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     placeholder="400001"
//                                     required
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Plate Count & Budget */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaUtensils size={15} />
//                             <span>Plate Count & Budget</span>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Veg Plates</label>
//                                 <input
//                                     name="vegPlates"
//                                     type="number"
//                                     value={formData.vegPlates || 0}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     min="0"
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Non-Veg Plates</label>
//                                 <input
//                                     name="nonVegPlates"
//                                     type="number"
//                                     value={formData.nonVegPlates || 0}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     min="0"
//                                 />
//                             </div>
//                         </div>
//                         <div style={formRowStyle}>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Mixed Plates</label>
//                                 <input
//                                     name="mixedPlates"
//                                     type="number"
//                                     value={formData.mixedPlates || 0}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     min="0"
//                                 />
//                             </div>
//                             <div style={formGroupStyle}>
//                                 <label style={labelStyle}>Budget (₹)</label>
//                                 <input
//                                     name="budget"
//                                     type="number"
//                                     value={formData.budget || 0}
//                                     onChange={handleInputChange}
//                                     style={inputStyle}
//                                     min="0"
//                                     placeholder="0"
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Add-ons Section */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaCheckCircle size={15} />
//                             <span>Add-ons</span>
//                         </div>
//                         <div style={addonsGridStyle}>
//                             {addOns.map((addon, index) => (
//                                 <div key={index} style={addonCardStyle}>
//                                     <label style={checkboxLabelStyle}>
//                                         <input
//                                             type="checkbox"
//                                             checked={addon.selected}
//                                             onChange={() => handleAddOnToggle(index)}
//                                             style={checkboxStyle}
//                                         />
//                                         <span style={{ fontWeight: 500, fontSize: '13px' }}>{addon.label}</span>
//                                     </label>
//                                     {addon.selected && (
//                                         <input
//                                             type="number"
//                                             value={addon.quantity}
//                                             onChange={(e) => handleAddOnQuantity(index, e.target.value)}
//                                             style={addonQuantityStyle}
//                                             min="1"
//                                             placeholder="Qty"
//                                         />
//                                     )}
//                                 </div>
//                             ))}
//                         </div>
//                     </div>

//                     {/* Dishes Section */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaUtensils size={15} />
//                             <span>Select Dishes</span>
//                         </div>
//                         <div style={dishesGridStyle}>
//                             {availableDishes.length === 0 ? (
//                                 <div style={noDishesStyle}>No dishes available</div>
//                             ) : (
//                                 availableDishes.map(dish => (
//                                     <label key={dish.dishId} style={dishCheckboxStyle}>
//                                         <input
//                                             type="checkbox"
//                                             checked={selectedDishIds.includes(dish.dishId)}
//                                             onChange={() => handleDishSelect(dish.dishId)}
//                                             style={checkboxStyle}
//                                         />
//                                         <span style={{fontWeight: 500}}>{dish.dishName}</span>
//                                         <span style={dishPriceStyle}>₹{dish.effectivePrice || dish.dishPrice}</span>
//                                     </label>
//                                 ))
//                             )}
//                         </div>
//                     </div>

//                     {/* Additional Requests */}
//                     <div style={sectionStyle}>
//                         <div style={sectionTitleStyle}>
//                             <FaEdit size={15} />
//                             <span>Additional Requests</span>
//                         </div>
//                         <textarea
//                             name="additionalRequests"
//                             value={formData.additionalRequests || ''}
//                             onChange={handleInputChange}
//                             style={textareaStyle}
//                             rows="2"
//                             placeholder="Any special requests or requirements..."
//                         />
//                     </div>

//                     {/* GST Requirement */}
//                     <div style={formGroupStyle}>
//                         <label style={labelStyle}>GST Requirement</label>
//                         <input
//                             name="gstRequirement"
//                             value={formData.gstRequirement || ''}
//                             onChange={handleInputChange}
//                             style={inputStyle}
//                             placeholder="GST number if applicable"
//                         />
//                     </div>

//                     {/* Form Actions */}
//                     <div style={formActionStyle}>
//                         <button
//                             type="button"
//                             onClick={() => { resetForm(); setShowModal(false); }}
//                             style={cancelButtonStyle}
//                         >
//                             Cancel
//                         </button>
//                         <button type="submit" style={submitButtonStyle} disabled={submitting}>
//                             {submitting ? (
//                                 <>
//                                     <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
//                                     {isEdit ? 'Updating...' : 'Creating...'}
//                                 </>
//                             ) : (
//                                 <>
//                                     {isEdit ? <FaEdit size={14} /> : <FaPlus size={14} />}
//                                     {submitLabel}
//                                 </>
//                             )}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// // ─── Styles ──────────────────────────────────────────────────────

// const containerStyle = {


// };

// const headerStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '24px',
//     flexWrap: 'wrap',
//     gap: '16px',
// };

// const headerLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
// };

// const headerIconStyle = {
//     width: '44px',
//     height: '44px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     borderRadius: '12px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     color: '#fff',
// };

// const titleStyle = {
//     fontSize: '24px',
//     fontWeight: 700,
//     color: '#111827',
//     margin: 0,
//     letterSpacing: '-0.5px',
// };

// const subtitleStyle = {
//     fontSize: '14px',
//     color: '#6B7280',
//     margin: '4px 0 0 0',
// };

// const createButtonStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 24px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '10px',
//     fontWeight: 600,
//     fontSize: '14px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
// };

// const statsContainerStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(4, 1fr)',
//     gap: '16px',
//     marginBottom: '24px',
// };

// const statCardStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
//     background: '#fff',
//     padding: '18px 20px',
//     borderRadius: '12px',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//     border: '1px solid #E5E7EB',
//     transition: 'all 0.2s ease',
// };

// const statIconWrapperStyle = {
//     width: '44px',
//     height: '44px',
//     borderRadius: '10px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
// };

// const statNumberStyle = {
//     fontSize: '22px',
//     fontWeight: 700,
//     color: '#111827',
//     lineHeight: 1.2,
// };

// const statLabelStyle = {
//     fontSize: '13px',
//     color: '#6B7280',
//     fontWeight: 500,
// };

// const searchFilterContainerStyle = {
//     display: 'flex',
//     gap: '12px',
//     marginBottom: '24px',
//     flexWrap: 'wrap',
//     alignItems: 'center',
// };

// const searchContainerStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     flex: 1,
//     minWidth: '200px',
//     background: '#fff',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     padding: '0 16px',
//     transition: 'all 0.2s ease',
// };

// const searchIconStyle = {
//     color: '#9CA3AF',
//     marginRight: '12px',
// };

// const searchInputStyle = {
//     flex: 1,
//     padding: '11px 0',
//     border: 'none',
//     outline: 'none',
//     fontSize: '14px',
//     background: 'transparent',
//     color: '#111827',
// };

// const filterContainerStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     background: '#fff',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     padding: '0 14px',
//     cursor: 'pointer',
// };

// const filterIconStyle = {
//     color: '#6B7280',
//     marginRight: '10px',
//     fontSize: '13px',
// };

// const filterSelectStyle = {
//     padding: '11px 4px',
//     border: 'none',
//     outline: 'none',
//     fontSize: '14px',
//     background: 'transparent',
//     cursor: 'pointer',
//     color: '#111827',
//     appearance: 'none',
//     paddingRight: '4px',
// };

// const refreshButtonStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '6px',
//     padding: '10px 18px',
//     background: '#fff',
//     color: '#4B5563',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     fontWeight: 500,
//     fontSize: '13px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// const tableCardStyle = {
//     background: '#fff',
//     borderRadius: '12px',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//     overflow: 'hidden',
//     border: '1px solid #E5E7EB',
// };

// const tableWrapperStyle = {
//     overflowX: 'auto',
//     padding: '0',
// };

// const tableStyle = {
//     width: '100%',
//     borderCollapse: 'collapse',
//     minWidth: '1100px',
// };

// const thStyle = {
//     padding: '12px 16px',
//     fontSize: '12px',
//     fontWeight: 600,
//     color: '#6B7280',
//     textTransform: 'uppercase',
//     letterSpacing: '0.5px',
//     background: '#F9FAFB',
//     borderBottom: '1px solid #E5E7EB',
// };

// const tdStyle = {
//     padding: '12px 16px',
//     fontSize: '13px',
//     color: '#111827',
//     borderBottom: '1px solid #F3F4F6',
// };

// const tableRowStyle = {
//     transition: 'background 0.15s ease',
//     cursor: 'default',
// };

// const customerCellStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
// };

// const avatarStyle = {
//     width: '32px',
//     height: '32px',
//     borderRadius: '50%',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     color: '#fff',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '13px',
//     fontWeight: 600,
//     flexShrink: 0,
// };

// const badgeStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '4px',
//     padding: '4px 12px',
//     borderRadius: '20px',
//     fontSize: '11px',
//     fontWeight: 600,
// };

// const eventBadgeStyle = {
//     display: 'inline-block',
//     padding: '2px 10px',
//     background: '#F3F4F6',
//     borderRadius: '6px',
//     fontSize: '12px',
//     fontWeight: 500,
//     color: '#4B5563',
// };

// const cityBadgeStyle = {
//     display: 'inline-block',
//     padding: '2px 10px',
//     background: '#EEF2FF',
//     borderRadius: '6px',
//     fontSize: '12px',
//     fontWeight: 500,
//     color: '#4F46E5',
// };

// const platesBadgeStyle = {
//     display: 'inline-block',
//     padding: '2px 10px',
//     background: '#FEF3C7',
//     borderRadius: '6px',
//     fontSize: '12px',
//     fontWeight: 600,
//     color: '#92400E',
// };

// const actionGroupStyle = {
//     display: 'flex',
//     gap: '6px',
//     justifyContent: 'center',
// };

// const editButtonStyle = {
//     padding: '6px 10px',
//     background: '#34D399',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '13px',
// };

// const deleteButtonStyle = {
//     padding: '6px 10px',
//     background: '#F87171',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '13px',
// };

// const emptyStateStyle = {
//     padding: '60px 20px',
//     textAlign: 'center',
//     borderBottom: 'none',
// };

// const emptyStateContentStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '8px',
// };

// const loadingStyle = {
//     padding: '60px 20px',
//     textAlign: 'center',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '12px',
//     color: '#6B7280',
// };

// // ─── Modal Styles ──────────────────────────────────────────────

// const modalOverlayStyle = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'rgba(0,0,0,0.5)',
//     backdropFilter: 'blur(4px)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 9999,
//     padding: '20px',
//     animation: 'fadeIn 0.25s ease',
// };

// const modalStyle = {
//     background: '#fff',
//     borderRadius: '16px',
//     width: '100%',
//     maxWidth: '720px',
//     maxHeight: '90vh',
//     overflow: 'auto',
//     boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
//     animation: 'slideUp 0.3s ease',
// };

// const modalHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '20px 24px',
//     borderBottom: '1px solid #F3F4F6',
//     position: 'sticky',
//     top: 0,
//     background: '#fff',
//     zIndex: 1,
// };

// const modalHeaderLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
// };

// const modalHeaderIconStyle = {
//     width: '36px',
//     height: '36px',
//     borderRadius: '10px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     color: '#fff',
// };

// const modalTitleStyle = {
//     margin: 0,
//     fontSize: '18px',
//     fontWeight: 700,
//     color: '#111827',
// };

// const modalCloseStyle = {
//     background: '#F3F4F6',
//     border: 'none',
//     fontSize: '16px',
//     cursor: 'pointer',
//     color: '#6B7280',
//     padding: '6px 10px',
//     borderRadius: '8px',
//     transition: 'all 0.2s ease',
// };

// const modalBodyStyle = {
//     padding: '24px',
// };

// const sectionStyle = {
//     marginBottom: '20px',
//     paddingBottom: '20px',
//     borderBottom: '1px solid #F3F4F6',
// };

// const sectionTitleStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     fontSize: '14px',
//     fontWeight: 600,
//     color: '#374151',
//     marginBottom: '12px',
// };

// const formRowStyle = {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr',
//     gap: '14px',
// };

// const formGroupStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '5px',
// };

// const labelStyle = {
//     fontSize: '13px',
//     fontWeight: 500,
//     color: '#374151',
// };

// const inputStyle = {
//     padding: '10px 12px',
//     border: '1px solid #E5E7EB',
//     borderRadius: '8px',
//     fontSize: '14px',
//     outline: 'none',
//     transition: 'all 0.2s ease',
//     background: '#fff',
//     color: '#111827',
// };

// const selectStyle = {
//     ...inputStyle,
//     appearance: 'auto',
// };

// const textareaStyle = {
//     ...inputStyle,
//     resize: 'vertical',
//     fontFamily: 'inherit',
//     width: '100%',
// };

// const formActionStyle = {
//     display: 'flex',
//     gap: '12px',
//     justifyContent: 'flex-end',
//     marginTop: '8px',
//     paddingTop: '16px',
//     borderTop: '1px solid #F3F4F6',
// };

// const cancelButtonStyle = {
//     padding: '10px 24px',
//     background: '#F3F4F6',
//     color: '#4B5563',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 500,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// const submitButtonStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 28px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 600,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
// };

// // ─── Add-ons Styles ─────────────────────────────────────────────

// const addonsGridStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(2, 1fr)',
//     gap: '8px',
// };

// const addonCardStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     padding: '8px 12px',
//     background: '#F9FAFB',
//     borderRadius: '8px',
//     border: '1px solid #F3F4F6',
// };

// const checkboxLabelStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     flex: 1,
// };

// const checkboxStyle = {
//     width: '16px',
//     height: '16px',
//     accentColor: '#e66d33',
//     cursor: 'pointer',
// };

// const addonQuantityStyle = {
//     width: '60px',
//     padding: '4px 8px',
//     border: '1px solid #E5E7EB',
//     borderRadius: '6px',
//     fontSize: '13px',
//     textAlign: 'center',
//     background: '#fff',
// };

// // ─── Dishes Styles ──────────────────────────────────────────────

// const dishesGridStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(2, 1fr)',
//     gap: '6px',
//     maxHeight: '160px',
//     overflowY: 'auto',
//     padding: '4px 2px',
// };

// const dishCheckboxStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '6px 10px',
//     background: '#F9FAFB',
//     border: '1px solid #F3F4F6',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     fontSize: '13px',
//     transition: 'all 0.2s ease',
// };

// const dishPriceStyle = {
//     fontSize: '11px',
//     color: '#6B7280',
//     marginLeft: 'auto',
//     fontWeight: 500,
// };

// const noDishesStyle = {
//     color: '#9CA3AF',
//     fontSize: '13px',
//     padding: '8px 0',
// };

// export default SalesEnquiry;






// SalesEnquiry.jsx - Updated version

import React, { useState, useEffect } from 'react';
import {
    FaPlus, FaEye, FaEdit, FaTrash, FaTimes,
    FaUser, FaEnvelope, FaPhone, FaBuilding,
    FaMapMarkerAlt, FaCalendarAlt, FaUtensils,
    FaCheckCircle, FaSearch, FaFilter, FaClock,
    FaSpinner, FaSync, FaChevronDown, FaUsers,
    FaClipboardList, FaChartBar, FaPaperPlane
} from 'react-icons/fa';
import {
    getAllDishes,
    createEnquiry,
    getAllEnquiries,
    deleteEnquiry,
    getAllVendors,
    sendEnquiryToVendors,
    ENUMS,
    updateEnquiry,
    addItemsToEnquiry
} from '../../Servicefile/salesService';
import GoogleMapPicker from '../../GoogleMapPicker';

const SalesEnquiry = () => {
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showSendModal, setShowSendModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState('all');
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [enquiries, setEnquiries] = useState([]);
    const [dishes, setDishes] = useState([]);
    const [editingEnquiry, setEditingEnquiry] = useState(null);
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);
    const [vendors, setVendors] = useState([]);
    const [selectedVendors, setSelectedVendors] = useState([]);
    const [vendorSearchTerm, setVendorSearchTerm] = useState('');
    const [selectAll, setSelectAll] = useState(false);
    const [sendingEnquiry, setSendingEnquiry] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState();
    // Date filter states
    const [dateFilter, setDateFilter] = useState('all');
    const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');
    const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
    const [formData, setFormData] = useState({
        source: 'APP',
        sourceBy: '',
        fullName: '',
        email: '',
        phoneNumber: '',
        event: 'EVENT',
        eventType: 'WEDDING',
        eventDate: '',
        eventTime: '',
        fromDate: '',
        toDate: '',
        fullAddress: '',
        city: '',
        state: '',
        country: 'India',
        companyName: '',
        vegPlates: 0,
        nonVegPlates: 0,
        mixedPlates: 0,
        additionalRequests: '',
        adminPermision: false,
        leadStatus: 'PENDING',
        budget: 0,
        latitude: 0,
        longitude: 0,
        pincode: '',
        gstRequirement: '',
        dishId: [],
        addOns: []
    });

    const addOnOptions = [
        { addOnType: 'SERVICE_BOYS', label: 'Service Boys', selected: false, quantity: 0 },
        { addOnType: 'PAPER_PLATES', label: 'Paper Plates', selected: false, quantity: 0 },
        { addOnType: 'WATER_BOTTLES', label: 'Water Bottles', selected: false, quantity: 0 },
        { addOnType: 'DISPOSABLE_CUPS', label: 'Disposable Cups', selected: false, quantity: 0 },
        { addOnType: 'TISSUE_PAPER', label: 'Tissue Paper', selected: false, quantity: 0 }
    ];
    const [showCustomDateModal, setShowCustomDateModal] = useState(false);
    const [addOns, setAddOns] = useState(addOnOptions);
    const [selectedDishIds, setSelectedDishIds] = useState([]);

    const [showMapPicker, setShowMapPicker] = useState(false);
    const [mapPickerFor, setMapPickerFor] = useState('create'); // 'create' or 'edit'

    // Add this function to handle location selection from map
    const handleLocationSelect = (locationData) => {

        // Update form data with selected location
        setFormData(prev => ({
            ...prev,
            latitude: locationData.latitude,
            longitude: locationData.longitude,
            fullAddress: locationData.address,
            // Extract city and state from address if needed
            city: locationData.address.split(',').slice(-3, -2)[0]?.trim() || prev.city,
            state: locationData.address.split(',').slice(-2, -1)[0]?.trim() || prev.state,
        }));
    };

    useEffect(() => {
        fetchDishes();
        fetchEnquiries();
        fetchVendors();
    }, []);

    // Date filter helper functions
    const getDateRange = (filterType) => {
        const today = new Date();
        const start = new Date();
        const end = new Date();

        switch (filterType) {
            case 'today':
                start.setHours(0, 0, 0, 0);
                end.setHours(23, 59, 59, 999);
                break;
            case 'yesterday':
                start.setDate(today.getDate() - 1);
                start.setHours(0, 0, 0, 0);
                end.setDate(today.getDate() - 1);
                end.setHours(23, 59, 59, 999);
                break;
            case 'week':
                const day = today.getDay();
                start.setDate(today.getDate() - day);
                start.setHours(0, 0, 0, 0);
                end.setDate(today.getDate() + (6 - day));
                end.setHours(23, 59, 59, 999);
                break;
            case 'month':
                start.setDate(1);
                start.setHours(0, 0, 0, 0);
                end.setHours(23, 59, 59, 999);
                break;
            case 'custom':
                if (customStartDate && customEndDate) {
                    return { from: new Date(customStartDate), to: new Date(customEndDate) };
                }
                return null;
            default:
                return null;
        }
        return { from: start, to: end };
    };

    const applyDateFilter = (enquiriesList) => {
        if (dateFilter === 'all') return enquiriesList;

        const range = getDateRange(dateFilter);
        if (!range) return enquiriesList;

        return enquiriesList.filter(enquiry => {
            const dateStr = enquiry.createdAt || enquiry.eventDate;
            if (!dateStr) return false;
            const enquiryDate = new Date(dateStr);
            return enquiryDate >= range.from && enquiryDate <= range.to;
        });
    };

    const getDateFilterLabel = () => {
        switch (dateFilter) {
            case 'all': return 'All Dates';
            case 'today': return 'Today';
            case 'yesterday': return 'Yesterday';
            case 'week': return 'This Week';
            case 'month': return 'This Month';
            case 'custom': return 'Custom Range';
            default: return 'All Dates';
        }
    };


    const fetchDishes = async () => {
        try {
            const data = await getAllDishes();
            setDishes(data || []);
        } catch (error) {
            console.error('Error fetching dishes:', error);
        }
    };

    const fetchEnquiries = async () => {
        setLoading(true);
        try {
            const data = await getAllEnquiries();
            setEnquiries(data || []);
        } catch (error) {
            console.error('Error fetching enquiries:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchVendors = async () => {
        try {
            const data = await getAllVendors();
            setVendors(data || []);
        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleAddOnToggle = (index) => {
        const updated = [...addOns];
        updated[index].selected = !updated[index].selected;
        if (!updated[index].selected) {
            updated[index].quantity = 0;
        }
        setAddOns(updated);
    };

    const handleAddOnQuantity = (index, value) => {
        const updated = [...addOns];
        updated[index].quantity = parseInt(value) || 0;
        setAddOns(updated);
    };

    const handleDishSelect = (dishId) => {
        setSelectedDishIds(prev => {
            if (prev.includes(dishId)) {
                return prev.filter(id => id !== dishId);
            } else {
                return [...prev, dishId];
            }
        });
    };

    const handleEditClick = (enquiry) => {
        setEditingEnquiry(enquiry);

        // Populate form data with enquiry data
        setFormData({
            source: enquiry.source || 'APP',
            sourceBy: enquiry.sourceBy || '',
            fullName: enquiry.fullName || '',
            email: enquiry.email || '',
            phoneNumber: enquiry.phoneNumber || '',
            event: enquiry.event || 'EVENT',
            eventType: enquiry.eventType || 'WEDDING',
            eventDate: enquiry.eventDate || '',
            eventTime: enquiry.eventTime || '',
            fromDate: enquiry.fromDate || '',
            toDate: enquiry.toDate || '',
            fullAddress: enquiry.fullAddress || '',
            city: enquiry.city || '',
            state: enquiry.state || '',
            country: enquiry.country || 'India',
            companyName: enquiry.companyName || '',
            vegPlates: enquiry.vegPlates || 0,
            nonVegPlates: enquiry.nonVegPlates || 0,
            mixedPlates: enquiry.mixedPlates || 0,
            additionalRequests: enquiry.additionalRequests || '',
            adminPermision: enquiry.adminPermision || false,
            leadStatus: enquiry.leadStatus || 'PENDING',
            budget: enquiry.budget || 0,
            latitude: enquiry.latitude || 0,
            longitude: enquiry.longitude || 0,
            pincode: enquiry.pincode || '',
            gstRequirement: enquiry.gstRequirement || '',
            dishId: enquiry.dishId || [],
            addOns: enquiry.addOns || []
        });

        // Set selected dish IDs
        setSelectedDishIds(enquiry.dishId || []);

        // Set add-ons
        if (enquiry.addOns && enquiry.addOns.length > 0) {
            const updatedAddOns = addOnOptions.map(option => {
                const existing = enquiry.addOns.find(a => a.addOnType === option.addOnType);
                return {
                    ...option,
                    selected: !!existing,
                    quantity: existing?.quantity || 0
                };
            });
            setAddOns(updatedAddOns);
        } else {
            setAddOns(addOnOptions);
        }

        setShowEditModal(true);
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();

        if (!formData.fullName) {
            alert('Please enter full name');
            return;
        }
        if (!formData.email) {
            alert('Please enter email');
            return;
        }
        if (!formData.phoneNumber) {
            alert('Please enter phone number');
            return;
        }

        if (formData.event === 'EVENT') {
            if (!formData.eventDate) {
                alert('Please select event date');
                return;
            }
        } else if (formData.event === 'DAILY') {
            if (!formData.fromDate || !formData.toDate) {
                alert('Please select from and to dates');
                return;
            }
        }

        const selectedAddOns = addOns
            .filter(a => a.selected)
            .map(a => ({
                addOnType: a.addOnType,
                quantity: a.quantity || 1,
                selected: true
            }));

        const requestBody = {
            source: formData.source || 'APP',
            sourceBy: formData.sourceBy || '',
            fullName: formData.fullName,
            email: formData.email,
            phoneNumber: formData.phoneNumber,
            event: formData.event || 'EVENT',
            eventType: formData.eventType || 'WEDDING',
            eventDate: formData.eventDate ? formatDateForAPI(formData.eventDate) : '',
            eventTime: formData.eventTime || '',
            fromDate: formData.fromDate ? formatDateForAPI(formData.fromDate) : '',
            toDate: formData.toDate ? formatDateForAPI(formData.toDate) : '',
            fullAddress: formData.fullAddress || '',
            city: formData.city || '',
            state: formData.state || '',
            country: formData.country || 'India',
            companyName: formData.companyName || '',
            vegPlates: parseInt(formData.vegPlates) || 0,
            nonVegPlates: parseInt(formData.nonVegPlates) || 0,
            mixedPlates: parseInt(formData.mixedPlates) || 0,
            additionalRequests: formData.additionalRequests || '',
            adminPermision: formData.adminPermision || false,
            leadStatus: formData.leadStatus || 'PENDING',
            budget: parseFloat(formData.budget) || 0,
            latitude: parseFloat(formData.latitude) || 0,
            longitude: parseFloat(formData.longitude) || 0,
            pincode: parseInt(formData.pincode) || 0,
            gstRequirement: formData.gstRequirement || '',
            addOns: selectedAddOns
        };

        setSubmitting(true);
        try {
            const enquiryId = editingEnquiry.id || editingEnquiry.enquiryId;

            // Step 1: Update the enquiry
            await updateEnquiry(enquiryId, requestBody);

            // Step 2: If there are selected dishes, add them using the additems API
            if (selectedDishIds.length > 0) {
                await addItemsToEnquiry(enquiryId, selectedDishIds);
            }

            alert('Enquiry updated successfully!');
            setShowEditModal(false);
            resetForm();
            fetchEnquiries();
        } catch (error) {
            console.error('Error updating enquiry:', error);
            alert(error.response?.data?.message || 'Failed to update enquiry');
        } finally {
            setSubmitting(false);
        }
    };

    const getMinDate = () => {
        const date = new Date();
        date.setDate(date.getDate() + 2);
        return date.toISOString().split('T')[0];
    };

    const getMaxDate = () => {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 3);
        return date.toISOString().split('T')[0];
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.fullName) {
            alert('Please enter full name');
            return;
        }
        if (!formData.email) {
            alert('Please enter email');
            return;
        }
        if (!formData.phoneNumber) {
            alert('Please enter phone number');
            return;
        }

        if (formData.event === 'EVENT') {
            if (!formData.eventDate) {
                alert('Please select event date');
                return;
            }
        } else if (formData.event === 'DAILY') {
            if (!formData.fromDate || !formData.toDate) {
                alert('Please select from and to dates');
                return;
            }
        }

        const selectedAddOns = addOns
            .filter(a => a.selected)
            .map(a => ({
                addOnType: a.addOnType,
                quantity: a.quantity || 1,
                selected: true
            }));

        const requestBody = {
            ...formData,
            eventDate: formData.eventDate ? formatDateForAPI(formData.eventDate) : '',
            fromDate: formData.fromDate ? formatDateForAPI(formData.fromDate) : '',
            toDate: formData.toDate ? formatDateForAPI(formData.toDate) : '',
            eventTime: formData.eventTime || '',
            addOns: selectedAddOns,
            dishId: selectedDishIds,
            pincode: parseInt(formData.pincode) || 0,
            budget: parseFloat(formData.budget) || 0,
            vegPlates: parseInt(formData.vegPlates) || 0,
            nonVegPlates: parseInt(formData.nonVegPlates) || 0,
            mixedPlates: parseInt(formData.mixedPlates) || 0
        };

        setSubmitting(true);
        try {
            await createEnquiry(requestBody);
            alert('Enquiry created successfully!');
            setShowCreateModal(false);
            resetForm();
            fetchEnquiries();
        } catch (error) {
            console.error('Error creating enquiry:', error);
            alert(error.response?.data?.message || 'Failed to create enquiry');
        } finally {
            setSubmitting(false);
        }
    };

    const resetForm = () => {
        setFormData({
            source: 'APP',
            sourceBy: '',
            fullName: '',
            email: '',
            phoneNumber: '',
            event: 'EVENT',
            eventType: 'WEDDING',
            eventDate: '',
            eventTime: '',
            fromDate: '',
            toDate: '',
            fullAddress: '',
            city: '',
            state: '',
            country: 'India',
            companyName: '',
            vegPlates: 0,
            nonVegPlates: 0,
            mixedPlates: 0,
            additionalRequests: '',
            adminPermision: false,
            leadStatus: 'PENDING',
            budget: 0,
            latitude: 0,
            longitude: 0,
            pincode: '',
            gstRequirement: '',
            dishId: [],
            addOns: []
        });
        setAddOns(addOnOptions);
        setSelectedDishIds([]);
        setEditingEnquiry(null);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this enquiry?')) return;

        try {
            await deleteEnquiry(id);
            alert('Enquiry deleted successfully!');
            fetchEnquiries();
        } catch (error) {
            console.error('Error deleting enquiry:', error);
            alert('Failed to delete enquiry');
        }
    };

    const handleSendEnquiry = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setSelectedVendors([]);
        setSelectAll(false);
        setVendorSearchTerm('');
        setPaymentAmount(0);
        setShowSendModal(true);
    };

    const handleVendorSelect = (vendorId) => {
        setSelectedVendors(prev => {
            if (prev.includes(vendorId)) {
                return prev.filter(id => id !== vendorId);
            } else {
                return [...prev, vendorId];
            }
        });
        setSelectAll(false);
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedVendors([]);
        } else {
            const allVendorIds = filteredVendors.map(v => v.vendorId);
            setSelectedVendors(allVendorIds);
        }
        setSelectAll(!selectAll);
    };

    const handleSendToVendors = async () => {
        if (selectedVendors.length === 0) {
            alert('Please select at least one vendor');
            return;
        }

        setSendingEnquiry(true);
        try {
            const payload = {
                adminPermision: true,
                paymentAmount: paymentAmount || 0,
                vendorIds: selectedVendors,
                assignToAll: false
            };

            await sendEnquiryToVendors(selectedEnquiry.id, payload);
            alert('Enquiry sent to vendors successfully!');
            setShowSendModal(false);
            setSelectedEnquiry(null);
            fetchEnquiries();
        } catch (error) {
            console.error('Error sending enquiry:', error);
            alert(error.response?.data?.message || 'Failed to send enquiry to vendors');
        } finally {
            setSendingEnquiry(false);
        }
    };

    const getStatusBadge = (status) => {
        const statusMap = {
            'PENDING': { bg: '#FEF3C7', color: '#92400E', label: 'Pending', icon: <FaClock size={10} /> },
            'IN_PROGRESS': { bg: '#DBEAFE', color: '#1E40AF', label: 'In Progress', icon: <FaSync size={10} /> },
            'QUOTED': { bg: '#E0E7FF', color: '#3730A3', label: 'Quoted', icon: <FaCheckCircle size={10} /> },
            'APPROVED': { bg: '#D1FAE5', color: '#065F46', label: 'Approved', icon: <FaCheckCircle size={10} /> },
            'REJECTED': { bg: '#FEE2E2', color: '#991B1B', label: 'Rejected', icon: <FaTimes size={10} /> },
            'CLOSED': { bg: '#F3F4F6', color: '#4B5563', label: 'Closed', icon: <FaTimes size={10} /> }
        };
        const statusInfo = statusMap[status] || statusMap['PENDING'];
        return (
            <span style={{
                ...badgeStyle,
                background: statusInfo.bg,
                color: statusInfo.color
            }}>
                {statusInfo.icon} {statusInfo.label}
            </span>
        );
    };

    const filteredEnquiries = applyDateFilter(enquiries).filter(e => {
        const matchesSearch =
            (e.fullName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (e.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (e.companyName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            (e.city || '').toLowerCase().includes(searchTerm.toLowerCase());

        const matchesFilter = filterType === 'all' || e.leadStatus === filterType;

        return matchesSearch && matchesFilter;
    });

    const getStatusCount = (status) => {
        return enquiries.filter(e => e.leadStatus === status).length;
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch {
            return dateStr;
        }
    };

    const formatDateForAPI = (dateStr) => {
        if (!dateStr) return '';
        const parts = dateStr.split('-');
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    };

    const getTotalPlates = (enquiry) => {
        return (enquiry.vegPlates || 0) + (enquiry.nonVegPlates || 0) + (enquiry.mixedPlates || 0);
    };

    const filteredVendors = vendors.filter(vendor =>
        (vendor.registeredName || '').toLowerCase().includes(vendorSearchTerm.toLowerCase())
    );

    return (
        <div style={containerStyle}>
            {/* Header */}
            <div style={headerStyle}>
                <div style={headerLeftStyle}>
                    <div style={headerIconStyle}>
                        <FaClipboardList size={22} />
                    </div>
                    <div>
                        <h2 style={titleStyle}>Sales Enquiries</h2>
                        <p style={subtitleStyle}>Manage all customer enquiries in one place</p>
                    </div>
                </div>
                <button
                    onClick={() => { resetForm(); setShowCreateModal(true); }}
                    style={createButtonStyle}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                    <FaPlus size={14} />
                    New Enquiry
                </button>
            </div>

            {/* Stats Cards */}
            <div style={statsContainerStyle}>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#EEF2FF' }}>
                        <FaClipboardList style={{ color: '#4F46E5' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{enquiries.length}</div>
                        <div style={statLabelStyle}>Total Enquiries</div>
                    </div>
                </div>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#FEF3C7' }}>
                        <FaClock style={{ color: '#D97706' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{getStatusCount('PENDING')}</div>
                        <div style={statLabelStyle}>Pending</div>
                    </div>
                </div>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#E0E7FF' }}>
                        <FaCheckCircle style={{ color: '#4F46E5' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{getStatusCount('QUOTED')}</div>
                        <div style={statLabelStyle}>Quoted</div>
                    </div>
                </div>
                <div style={statCardStyle}>
                    <div style={{ ...statIconWrapperStyle, background: '#D1FAE5' }}>
                        <FaCheckCircle style={{ color: '#059669' }} size={20} />
                    </div>
                    <div>
                        <div style={statNumberStyle}>{getStatusCount('APPROVED')}</div>
                        <div style={statLabelStyle}>Approved</div>
                    </div>
                </div>
            </div>

            {/* Search and Filter */}
            {/* Search and Filter */}
            <div style={searchFilterContainerStyle}>
                <div style={searchContainerStyle}>
                    <FaSearch style={searchIconStyle} />
                    <input
                        type="text"
                        placeholder="Search by name, email, city..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={searchInputStyle}
                    />
                </div>

                {/* Date Filter */}
                <div style={dateFilterContainerStyle}>
                    <FaCalendarAlt style={filterIconStyle} />
                    <select
                        value={dateFilter}
                        onChange={(e) => {
                            const value = e.target.value;
                            setDateFilter(value);
                            if (value === 'custom') {
                                setShowCustomDateModal(true);
                            } else {
                                setShowCustomDatePicker(false);
                            }
                        }}
                        style={filterSelectStyle}
                    >
                        <option value="all" style={{ padding: "10px" }}>All Dates</option>
                        <option value="today" style={{ padding: "10px" }}>Today</option>
                        <option value="yesterday" style={{ padding: "10px" }}>Yesterday</option>
                        <option value="week" style={{ padding: "10px" }}>This Week</option>
                        <option value="month" style={{ padding: "10px" }}>This Month</option>
                        <option value="custom" style={{ padding: "10px", margin: "10px" }}>Custom Range</option>
                    </select>
                    <FaChevronDown style={{ color: '#9CA3AF', fontSize: '10px', marginLeft: '4px' }} />
                </div>

                {/* Custom Date Range */}
                {/* Custom Date Range Modal */}
                {showCustomDateModal && (
                    <div style={customDateModalOverlay} onClick={() => setShowCustomDateModal(false)}>
                        <div style={customDateModalStyle} onClick={(e) => e.stopPropagation()}>
                            <div style={customDateModalHeader}>
                                <h3 style={customDateModalTitle}>Select Custom Date Range</h3>
                                <button
                                    onClick={() => setShowCustomDateModal(false)}
                                    style={customDateModalClose}
                                >
                                    <FaTimes />
                                </button>
                            </div>
                            <div style={customDateModalBody}>
                                <div style={customDateModalInputGroup}>
                                    <label style={customDateModalLabel}>From Date</label>
                                    <input
                                        type="date"
                                        value={customStartDate}
                                        onChange={(e) => setCustomStartDate(e.target.value)}
                                        style={customDateModalInput}
                                        max={customEndDate || undefined}
                                    />
                                </div>
                                <div style={customDateModalInputGroup}>
                                    <label style={customDateModalLabel}>To Date</label>
                                    <input
                                        type="date"
                                        value={customEndDate}
                                        onChange={(e) => setCustomEndDate(e.target.value)}
                                        style={customDateModalInput}
                                        min={customStartDate || undefined}
                                        max={new Date().toISOString().split('T')[0]}
                                    />
                                </div>
                            </div>
                            <div style={customDateModalFooter}>
                                <button
                                    onClick={() => {
                                        setShowCustomDateModal(false);
                                        setCustomStartDate('');
                                        setCustomEndDate('');
                                    }}
                                    style={customDateModalCancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        if (customStartDate && customEndDate) {
                                            setDateFilter('custom');
                                            setShowCustomDateModal(false);
                                            setShowCustomDatePicker(false);
                                        } else {
                                            alert('Please select both start and end dates');
                                        }
                                    }}
                                    style={customDateModalApply}
                                >
                                    Apply Range
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <div style={filterContainerStyle}>
                    <FaFilter style={filterIconStyle} />
                    <select
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                        style={filterSelectStyle}
                    >
                        <option value="all">All Status</option>
                        <option value="PENDING">Pending</option>
                        <option value="QUOTED">Quoted</option>
                        <option value="APPROVED">Approved</option>
                        <option value="REJECTED">Rejected</option>
                        <option value="CLOSED">Closed</option>
                    </select>
                    <FaChevronDown style={{ color: '#9CA3AF', fontSize: '10px', marginLeft: '4px' }} />
                </div>
            </div>

            {/* Table */}
            <div style={tableCardStyle}>
                {loading ? (
                    <div style={loadingStyle}>
                        <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={32} color="#4F46E5" />
                        <p>Loading enquiries...</p>
                    </div>
                ) : (
                    <div style={tableWrapperStyle}>
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={{ ...thStyle, width: '4%', textAlign: 'center' }}>S.No</th>
                                    <th style={{ ...thStyle, width: '12%', textAlign: 'left' }}>Customer</th>
                                    <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>Event</th>
                                    <th style={{ ...thStyle, width: '12%', textAlign: 'center' }}>Date</th>
                                    <th style={{ ...thStyle, width: '8%', textAlign: 'center' }}>City</th>
                                    <th style={{ ...thStyle, width: '7%', textAlign: 'center' }}>Plates</th>
                                    <th style={{ ...thStyle, width: '9%', textAlign: 'center' }}>Budget</th>
                                    <th style={{ ...thStyle, width: '9%', textAlign: 'center' }}>Status</th>
                                    <th style={{ ...thStyle, width: '9%', textAlign: 'center' }}>Created</th>
                                    {/* <th style={{ ...thStyle, width: '22%', textAlign: 'center' }}>Actions</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredEnquiries.length === 0 ? (
                                    <tr>
                                        <td colSpan="10" style={emptyStateStyle}>
                                            <div style={emptyStateContentStyle}>
                                                <FaClipboardList size={40} color="#D1D5DB" />
                                                <p>No enquiries found</p>
                                                <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
                                                    Try adjusting your search or filter
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    filteredEnquiries.map((enquiry, index) => (
                                        <tr key={enquiry.id || enquiry.enquiryId || index} style={tableRowStyle}>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 500, color: '#9CA3AF' }}>
                                                {index + 1}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'left' }}>
                                                <div style={customerCellStyle}>
                                                    <div style={avatarStyle}>
                                                        {(enquiry.fullName || '?')[0].toUpperCase()}
                                                    </div>
                                                    <div>
                                                        <div style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>
                                                            {enquiry.fullName || '-'}
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: '#6B7280' }}>
                                                            {enquiry.email || '-'}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <span style={eventBadgeStyle}>
                                                    {enquiry.eventType || '-'}
                                                </span>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontSize: '12px', color: '#374151' }}>
                                                {enquiry.event === 'EVENT'
                                                    ? formatDate(enquiry.eventDate)
                                                    : `${formatDate(enquiry.fromDate)} - ${formatDate(enquiry.toDate)}`}

                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <span style={cityBadgeStyle}>
                                                    {enquiry.city || '-'}
                                                </span>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <span style={platesBadgeStyle}>
                                                    {getTotalPlates(enquiry)}
                                                </span>
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#059669' }}>
                                                ₹{Number(enquiry.budget || 0).toLocaleString()}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                {getStatusBadge(enquiry.leadStatus)}
                                            </td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontSize: '12px', color: '#6B7280' }}>
                                                {formatDate(enquiry.createdAt)}
                                            </td>
                                            {/* <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                <div style={actionGroupStyle}>
                                                    <button
                                                        style={editButtonStyle}
                                                        title="Edit"
                                                        onClick={() => handleEditClick(enquiry)}
                                                        onMouseEnter={(e) => e.currentTarget.style.background = '#10B981'}
                                                        onMouseLeave={(e) => e.currentTarget.style.background = '#34D399'}
                                                    >
                                                        <FaEdit size={13} />
                                                    </button>
                                                    <button
                                                        style={deleteButtonStyle}
                                                        title="Delete"
                                                        onClick={() => handleDelete(enquiry.id || enquiry.enquiryId)}
                                                        onMouseEnter={(e) => e.currentTarget.style.background = '#EF4444'}
                                                        onMouseLeave={(e) => e.currentTarget.style.background = '#F87171'}
                                                    >
                                                        <FaTrash size={13} />
                                                    </button>
                                                    {enquiry.leadStatus === 'PENDING' && (
                                                        <button
                                                            style={sendButtonStyle}
                                                            title="Send to Vendors"
                                                            onClick={() => handleSendEnquiry(enquiry)}
                                                            onMouseEnter={(e) => e.currentTarget.style.background = '#7C3AED'}
                                                            onMouseLeave={(e) => e.currentTarget.style.background = '#8B5CF6'}
                                                        >
                                                            <FaPaperPlane size={13} />
                                                        </button>
                                                    )}
                                                </div>
                                            </td> */}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Create Enquiry Modal */}
            {showCreateModal && (
                <EnquiryModal
                    formData={formData}
                    setFormData={setFormData}
                    addOns={addOns}
                    setAddOns={setAddOns}
                    dishes={dishes}
                    selectedDishIds={selectedDishIds}
                    setSelectedDishIds={setSelectedDishIds}
                    handleInputChange={handleInputChange}
                    handleAddOnToggle={handleAddOnToggle}
                    handleAddOnQuantity={handleAddOnQuantity}
                    handleDishSelect={handleDishSelect}
                    handleSubmit={handleSubmit}
                    resetForm={resetForm}
                    setShowModal={setShowCreateModal}
                    submitting={submitting}
                    getMinDate={getMinDate}
                    getMaxDate={getMaxDate}
                    ENUMS={ENUMS}
                    title="New Enquiry"
                    submitLabel="Create Enquiry"
                    showMapPicker={showMapPicker}
                    setShowMapPicker={setShowMapPicker}
                    setMapPickerFor={setMapPickerFor}
                    onLocationSelect={handleLocationSelect}
                />
            )}

            {/* Edit Enquiry Modal */}
            {/* Edit Enquiry Modal */}
            {showEditModal && editingEnquiry && (
                <EnquiryModal
                    formData={formData}
                    setFormData={setFormData}
                    addOns={addOns}
                    setAddOns={setAddOns}
                    dishes={dishes}
                    selectedDishIds={selectedDishIds}
                    setSelectedDishIds={setSelectedDishIds}
                    handleInputChange={handleInputChange}
                    handleAddOnToggle={handleAddOnToggle}
                    handleAddOnQuantity={handleAddOnQuantity}
                    handleDishSelect={handleDishSelect}
                    handleSubmit={handleUpdateSubmit}  // ← Changed from inline function
                    resetForm={resetForm}
                    setShowModal={setShowEditModal}
                    submitting={submitting}
                    getMinDate={getMinDate}
                    getMaxDate={getMaxDate}
                    ENUMS={ENUMS}
                    title="Edit Enquiry"
                    submitLabel="Update Enquiry"
                    isEdit={true}
                    showMapPicker={showMapPicker}
                    setShowMapPicker={setShowMapPicker}
                    setMapPickerFor={setMapPickerFor}
                    onLocationSelect={handleLocationSelect}
                />
            )}

            {/* Send to Vendors Modal */}
            {showSendModal && selectedEnquiry && (
                <div style={modalOverlayStyle} onClick={() => setShowSendModal(false)}>
                    <div style={{ ...modalStyle, maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={{ ...modalHeaderIconStyle, background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)' }}>
                                    <FaPaperPlane size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>Send to Vendors</h3>
                            </div>
                            <button onClick={() => setShowSendModal(false)} style={modalCloseStyle}>
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            {/* Enquiry Info */}
                            <div style={sendEnquiryInfoStyle}>
                                <div style={sendEnquiryInfoItemStyle}>
                                    <span style={{ fontWeight: 500 }}>Customer:</span>
                                    <span>{selectedEnquiry.fullName}</span>
                                </div>
                                <div style={sendEnquiryInfoItemStyle}>
                                    <span style={{ fontWeight: 500 }}>Event:</span>
                                    <span>{selectedEnquiry.eventType}</span>
                                </div>
                                <div style={sendEnquiryInfoItemStyle}>
                                    <span style={{ fontWeight: 500 }}>Budget:</span>
                                    <span style={{ color: '#059669', fontWeight: 600 }}>₹{Number(selectedEnquiry.budget || 0).toLocaleString()}</span>
                                </div>
                            </div>

                            {/* Payment Amount */}
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Lead Price</label>
                                <input
                                    type="number"
                                    value={paymentAmount}
                                    onChange={(e) => setPaymentAmount(parseFloat(e.target.value))}
                                    style={inputStyle}
                                    placeholder="Enter Lead Price"

                                />
                            </div>

                            {/* <div style={formGroupStyle}>
                                <label style={labelStyle}>Payment Amount</label>
                                <input
                                    type="number"
                                    value={selectedEnquiry?.budget || 0}
                                    readOnly
                                    style={{
                                        ...inputStyle,
                                        background: '#F0FDF4',
                                        border: '2px solid #059669',
                                        color: '#059669',
                                        fontWeight: 600,
                                        cursor: 'not-allowed'
                                    }}
                                />

                            </div> */}

                            {/* Vendor Search */}
                            <div style={{ ...searchContainerStyle, marginBottom: '12px', marginTop: "12px" }}>
                                <FaSearch style={searchIconStyle} />
                                <input
                                    type="text"
                                    placeholder="Search vendors..."
                                    value={vendorSearchTerm}
                                    onChange={(e) => setVendorSearchTerm(e.target.value)}
                                    style={searchInputStyle}
                                />
                            </div>

                            {/* Select All */}
                            <div style={selectAllContainerStyle}>
                                <label style={selectAllLabelStyle}>
                                    <input
                                        type="checkbox"
                                        checked={selectAll}
                                        onChange={handleSelectAll}
                                        style={checkboxStyle}
                                    />
                                    <span style={{ fontWeight: 600 }}>Select All Vendors</span>
                                </label>
                                <span style={{ fontSize: '12px', color: '#6B7280' }}>
                                    {selectedVendors.length} selected
                                </span>
                            </div>

                            {/* Vendor List */}
                            <div style={vendorListStyle}>
                                {filteredVendors.length === 0 ? (
                                    <div style={noVendorsStyle}>No vendors found</div>
                                ) : (
                                    filteredVendors.map(vendor => (
                                        <label key={vendor.vendorId} style={vendorItemStyle}>
                                            <input
                                                type="checkbox"
                                                checked={selectedVendors.includes(vendor.vendorId)}
                                                onChange={() => handleVendorSelect(vendor.vendorId)}
                                                style={checkboxStyle}
                                            />
                                            <div>
                                                <div style={{ fontWeight: 500, fontSize: '14px' }}>
                                                    {vendor.registeredName || 'Unnamed Vendor'}
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#6B7280' }}>
                                                    {vendor.city || 'City not specified'} • {vendor.mobileNumber || 'No phone'}
                                                </div>
                                            </div>
                                        </label>
                                    ))
                                )}
                            </div>

                            {/* Actions */}
                            <div style={formActionStyle}>
                                <button
                                    type="button"
                                    onClick={() => setShowSendModal(false)}
                                    style={cancelButtonStyle}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={handleSendToVendors}
                                    style={submitButtonStyle}
                                    disabled={sendingEnquiry || selectedVendors.length === 0}
                                >
                                    {sendingEnquiry ? (
                                        <>
                                            <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
                                            Sending...
                                        </>
                                    ) : (
                                        <>
                                            <FaPaperPlane size={14} />
                                            Send to {selectedVendors.length} Vendor{selectedVendors.length > 1 ? 's' : ''}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showMapPicker && (
                <GoogleMapPicker
                    onLocationSelect={handleLocationSelect}
                    onClose={() => setShowMapPicker(false)}
                    initialLat={formData.latitude || 17.3850}
                    initialLng={formData.longitude || 78.4867}
                    initialAddress={formData.fullAddress || ''}
                />
            )}

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

const EnquiryModal = ({
    formData,
    setFormData,
    addOns,
    setAddOns,
    dishes,
    selectedDishIds,
    setSelectedDishIds,
    handleInputChange,
    handleAddOnToggle,
    handleAddOnQuantity,
    handleDishSelect,
    handleSubmit,
    resetForm,
    setShowModal,
    submitting,
    getMinDate,
    getMaxDate,
    ENUMS,
    title,
    submitLabel,
    showMapPicker,
    setShowMapPicker,
    setMapPickerFor,
    onLocationSelect,
    isEdit = false

}) => {
    const availableDishes = dishes.filter(d => d.parentId !== null && d.parentId !== undefined);

    return (
        <div style={modalOverlayStyle} onClick={() => setShowModal(false)}>
            <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
                <div style={modalHeaderStyle}>
                    <div style={modalHeaderLeftStyle}>
                        <div style={modalHeaderIconStyle}>
                            {isEdit ? <FaEdit size={18} /> : <FaPlus size={18} />}
                        </div>
                        <h3 style={modalTitleStyle}>{title}</h3>
                    </div>
                    <button onClick={() => setShowModal(false)} style={modalCloseStyle}>
                        <FaTimes />
                    </button>
                </div>

                <form onSubmit={handleSubmit} style={modalBodyStyle}>
                    {/* Source */}
                    <div style={formRowStyle}>
                        <div style={formGroupStyle}>
                            <label style={labelStyle}>Source <span style={{ color: '#EF4444' }}>*</span></label>
                            <select
                                name="source"
                                value={formData.source || 'APP'}
                                onChange={handleInputChange}
                                style={selectStyle}
                                required
                            >
                                {ENUMS.source.map(s => (
                                    <option key={s} value={s}>{s.replace('_', ' ')}</option>
                                ))}
                            </select>
                        </div>
                        <div style={formGroupStyle}>
                            <label style={labelStyle}>Source By</label>
                            <input
                                name="sourceBy"
                                value={formData.sourceBy || ''}
                                onChange={handleInputChange}
                                style={inputStyle}
                                placeholder="Reference"
                            />
                        </div>
                    </div>

                    {/* Customer Details */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaUser size={15} />
                            <span>Customer Details</span>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Full Name <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="fullName"
                                    value={formData.fullName || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="John Doe"
                                    required
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Email <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="email"
                                    type="email"
                                    value={formData.email || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="john@example.com"
                                    required
                                />
                            </div>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Phone Number <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="phoneNumber"
                                    value={formData.phoneNumber || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="+91 98765 43210"
                                    required
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Company Name</label>
                                <input
                                    name="companyName"
                                    value={formData.companyName || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="Company name"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Event Details Section - ADD THIS BACK */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaCalendarAlt size={15} />
                            <span>Event Details</span>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Event <span style={{ color: '#EF4444' }}>*</span></label>
                                <select
                                    name="event"
                                    value={formData.event || 'EVENT'}
                                    onChange={handleInputChange}
                                    style={selectStyle}
                                    required
                                >
                                    {ENUMS.event.map(e => (
                                        <option key={e} value={e}>{e}</option>
                                    ))}
                                </select>
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Event Type <span style={{ color: '#EF4444' }}>*</span></label>
                                <select
                                    name="eventType"
                                    value={formData.eventType || (formData.event === 'DAILY' ? 'DAILY' : 'WEDDING')}
                                    onChange={handleInputChange}
                                    style={selectStyle}
                                    required
                                >
                                    {formData.event === 'DAILY' ? (
                                        ['DAILY', 'WEEKLY', 'MONTHLY', 'CORPORATE', 'OTHER'].map(e => (
                                            <option key={e} value={e}>{e}</option>
                                        ))
                                    ) : (
                                        ENUMS.eventType.filter(e => !['DAILY', 'WEEKLY', 'MONTHLY', 'CORPORATE'].includes(e)).map(e => (
                                            <option key={e} value={e}>{e}</option>
                                        ))
                                    )}
                                </select>
                            </div>
                        </div>

                        {/* Date/Time Fields - Based on Event Type */}
                        {formData.event === 'EVENT' ? (
                            <div style={formRowStyle}>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Event Date <span style={{ color: '#EF4444' }}>*</span></label>
                                    <input
                                        name="eventDate"
                                        type="date"
                                        value={formData.eventDate || ''}
                                        onChange={handleInputChange}
                                        style={inputStyle}
                                        min={getMinDate()}
                                        max={getMaxDate()}
                                        required
                                    />
                                </div>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>Event Time</label>
                                    <input
                                        name="eventTime"
                                        type="time"
                                        value={formData.eventTime || ''}
                                        onChange={handleInputChange}
                                        style={inputStyle}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div style={formRowStyle}>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>From Date <span style={{ color: '#EF4444' }}>*</span></label>
                                    <input
                                        name="fromDate"
                                        type="date"
                                        value={formData.fromDate || ''}
                                        onChange={handleInputChange}
                                        style={inputStyle}
                                        min={getMinDate()}
                                        max={getMaxDate()}
                                        required
                                    />
                                </div>
                                <div style={formGroupStyle}>
                                    <label style={labelStyle}>To Date <span style={{ color: '#EF4444' }}>*</span></label>
                                    <input
                                        name="toDate"
                                        type="date"
                                        value={formData.toDate || ''}
                                        onChange={handleInputChange}
                                        style={inputStyle}
                                        min={getMinDate()}
                                        max={getMaxDate()}
                                        required
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Venue Details */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaMapMarkerAlt size={15} />
                            <span>Venue Details</span>
                        </div>
                        <div style={formGroupStyle}>
                            <label style={labelStyle}>Full Address <span style={{ color: '#EF4444' }}>*</span></label>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <textarea
                                    name="fullAddress"
                                    value={formData.fullAddress || ''}
                                    onChange={handleInputChange}
                                    style={{ ...textareaStyle, flex: 1 }}
                                    rows="2"
                                    placeholder="123 Main St, City"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (typeof setShowMapPicker === 'function' && typeof setMapPickerFor === 'function') {
                                            setMapPickerFor(isEdit ? 'edit' : 'create');
                                            setShowMapPicker(true);
                                        }
                                    }}
                                    style={{
                                        padding: '10px 14px',
                                        background: '#e66d33',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '20px',
                                        minHeight: '56px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'all 0.2s ease',
                                        flexShrink: 0,
                                    }}
                                    title="Select location on map"
                                    onMouseEnter={(e) => e.currentTarget.style.background = '#d45f2a'}
                                    onMouseLeave={(e) => e.currentTarget.style.background = '#e66d33'}
                                >
                                    <FaMapMarkerAlt />
                                </button>
                            </div>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>City <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="city"
                                    value={formData.city || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="Mumbai"
                                    required
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>State <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="state"
                                    value={formData.state || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="Maharashtra"
                                    required
                                />
                            </div>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Country</label>
                                <input
                                    name="country"
                                    value={formData.country || 'India'}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Pincode <span style={{ color: '#EF4444' }}>*</span></label>
                                <input
                                    name="pincode"
                                    type="number"
                                    value={formData.pincode || ''}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    placeholder="400001"
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    {/* Plate Count & Budget */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaUtensils size={15} />
                            <span>Plate Count & Budget</span>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Veg Plates</label>
                                <input
                                    name="vegPlates"
                                    type="number"
                                    value={formData.vegPlates || 0}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    min="0"
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Non-Veg Plates</label>
                                <input
                                    name="nonVegPlates"
                                    type="number"
                                    value={formData.nonVegPlates || 0}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    min="0"
                                />
                            </div>
                        </div>
                        <div style={formRowStyle}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Mixed Plates</label>
                                <input
                                    name="mixedPlates"
                                    type="number"
                                    value={formData.mixedPlates || 0}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    min="0"
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Budget (₹)</label>
                                <input
                                    name="budget"
                                    type="number"
                                    value={formData.budget || 0}
                                    onChange={handleInputChange}
                                    style={inputStyle}
                                    min="0"
                                    placeholder="0"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Add-ons Section */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaCheckCircle size={15} />
                            <span>Add-ons</span>
                        </div>
                        <div style={addonsGridStyle}>
                            {addOns.map((addon, index) => (
                                <div key={index} style={addonCardStyle}>
                                    <label style={checkboxLabelStyle}>
                                        <input
                                            type="checkbox"
                                            checked={addon.selected}
                                            onChange={() => handleAddOnToggle(index)}
                                            style={checkboxStyle}
                                        />
                                        <span style={{ fontWeight: 500, fontSize: '13px' }}>{addon.label}</span>
                                    </label>
                                    {addon.selected && (
                                        <input
                                            type="number"
                                            value={addon.quantity}
                                            onChange={(e) => handleAddOnQuantity(index, e.target.value)}
                                            style={addonQuantityStyle}
                                            min="1"
                                            placeholder="Qty"
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Dishes Section */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaUtensils size={15} />
                            <span>Select Dishes</span>
                        </div>
                        <div style={dishesGridStyle}>
                            {availableDishes.length === 0 ? (
                                <div style={noDishesStyle}>No dishes available</div>
                            ) : (
                                availableDishes.map(dish => (
                                    <label key={dish.dishId} style={dishCheckboxStyle}>
                                        <input
                                            type="checkbox"
                                            checked={selectedDishIds.includes(dish.dishId)}
                                            onChange={() => handleDishSelect(dish.dishId)}
                                            style={checkboxStyle}
                                        />
                                        <span style={{ fontWeight: 500 }}>{dish.dishName}</span>
                                        <span style={dishPriceStyle}>₹{dish.effectivePrice || dish.dishPrice}</span>
                                    </label>
                                ))
                            )}
                        </div>
                    </div>

                    {/* Additional Requests */}
                    <div style={sectionStyle}>
                        <div style={sectionTitleStyle}>
                            <FaEdit size={15} />
                            <span>Additional Requests</span>
                        </div>
                        <textarea
                            name="additionalRequests"
                            value={formData.additionalRequests || ''}
                            onChange={handleInputChange}
                            style={textareaStyle}
                            rows="2"
                            placeholder="Any special requests or requirements..."
                        />
                    </div>

                    {/* GST Requirement */}
                    <div style={formGroupStyle}>
                        <label style={labelStyle}>GST Requirement</label>
                        <input
                            name="gstRequirement"
                            value={formData.gstRequirement || ''}
                            onChange={handleInputChange}
                            style={inputStyle}
                            placeholder="GST number if applicable"
                        />
                    </div>

                    {/* Form Actions */}
                    <div style={formActionStyle}>
                        <button
                            type="button"
                            onClick={() => { resetForm(); setShowModal(false); }}
                            style={cancelButtonStyle}
                        >
                            Cancel
                        </button>
                        <button type="submit" style={submitButtonStyle} disabled={submitting}>
                            {submitting ? (
                                <>
                                    <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
                                    {isEdit ? 'Updating...' : 'Creating...'}
                                </>
                            ) : (
                                <>
                                    {isEdit ? <FaEdit size={14} /> : <FaPlus size={14} />}
                                    {submitLabel}
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
// ─── Styles ──────────────────────────────────────────────────────

const containerStyle = {

};


const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '16px',
};

const headerLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
};

const headerIconStyle = {
    width: '44px',
    height: '44px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
};

const titleStyle = {
    fontSize: '24px',
    fontWeight: 700,
    color: '#111827',
    margin: 0,
    letterSpacing: '-0.5px',
};

const subtitleStyle = {
    fontSize: '14px',
    color: '#6B7280',
    margin: '4px 0 0 0',
};

const createButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 24px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontWeight: 600,
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
};

const statsContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px',
    marginBottom: '10px',
};

const statCardStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    background: '#fff',
    padding: '18px 20px',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    border: '1px solid #E5E7EB',
    transition: 'all 0.2s ease',
};

const statIconWrapperStyle = {
    width: '44px',
    height: '44px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const statNumberStyle = {
    fontSize: '22px',
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1.2,
};

const statLabelStyle = {
    fontSize: '13px',
    color: '#6B7280',
    fontWeight: 500,
};

const searchFilterContainerStyle = {
    display: 'flex',
    gap: '12px',
    marginBottom: '10px',
    flexWrap: 'wrap',
    alignItems: 'center',
};

const searchContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: '200px',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    padding: '0 16px',
    transition: 'all 0.2s ease',
};

const searchIconStyle = {
    color: '#9CA3AF',
    marginRight: '12px',
};

const searchInputStyle = {
    flex: 1,
    padding: '11px 0',
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    background: 'transparent',
    color: '#111827',
};

const filterContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    padding: '0 14px',
    cursor: 'pointer',
};

const filterIconStyle = {
    color: '#6B7280',
    marginRight: '10px',
    fontSize: '13px',
};

const filterSelectStyle = {
    padding: '11px 4px',
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    background: 'transparent',
    cursor: 'pointer',
    color: '#111827',
    appearance: 'none',
    paddingRight: '4px',
};

const refreshButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '10px 18px',
    background: '#fff',
    color: '#4B5563',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    fontWeight: 500,
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

const tableCardStyle = {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    border: '1px solid #E5E7EB',
};

const tableWrapperStyle = {
    overflowX: 'auto',
    padding: '0',
    maxHeight: "50vh",
    scrollbarWidth: "thin",
};

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '1100px',
};

const thStyle = {
    padding: '12px 16px',
    fontSize: '12px',
    fontWeight: 600,
    color: '#6B7280',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    background: '#F9FAFB',
    borderBottom: '1px solid #E5E7EB',
};

const tdStyle = {
    padding: '12px 16px',
    fontSize: '13px',
    color: '#111827',
    borderBottom: '1px solid #F3F4F6',
};

const tableRowStyle = {
    transition: 'background 0.15s ease',
    cursor: 'default',
};

const customerCellStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
};

const avatarStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: 600,
    flexShrink: 0,
};

const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: 600,
};

const eventBadgeStyle = {
    display: 'inline-block',
    padding: '2px 10px',
    background: '#F3F4F6',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#4B5563',
};

const cityBadgeStyle = {
    display: 'inline-block',
    padding: '2px 10px',
    background: '#EEF2FF',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#4F46E5',
};

const platesBadgeStyle = {
    display: 'inline-block',
    padding: '2px 10px',
    background: '#FEF3C7',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 600,
    color: '#92400E',
};

const actionGroupStyle = {
    display: 'flex',
    gap: '6px',
    justifyContent: 'center',
};

const editButtonStyle = {
    padding: '6px 10px',
    background: '#34D399',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const deleteButtonStyle = {
    padding: '6px 10px',
    background: '#F87171',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const emptyStateStyle = {
    padding: '60px 20px',
    textAlign: 'center',
    borderBottom: 'none',
};

const emptyStateContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
};

const loadingStyle = {
    padding: '60px 20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    color: '#6B7280',
};

// ─── Modal Styles ──────────────────────────────────────────────

const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px',
    animation: 'fadeIn 0.25s ease',
};

const modalStyle = {
    background: '#fff',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '720px',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
    animation: 'slideUp 0.3s ease',
};

const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #F3F4F6',
    position: 'sticky',
    top: 0,
    background: '#fff',
    zIndex: 1,
};

const modalHeaderLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
};

const modalHeaderIconStyle = {
    width: '36px',
    height: '36px',
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
};

const modalTitleStyle = {
    margin: 0,
    fontSize: '18px',
    fontWeight: 700,
    color: '#111827',
};

const modalCloseStyle = {
    background: '#F3F4F6',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    color: '#6B7280',
    padding: '6px 10px',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
};

const modalBodyStyle = {
    padding: '24px',
};

const sectionStyle = {
    marginBottom: '20px',
    paddingBottom: '20px',
    borderBottom: '1px solid #F3F4F6',
};

const sectionTitleStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: 600,
    color: '#374151',
    marginBottom: '12px',
};

const formRowStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '14px',
};

const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
};

const labelStyle = {
    fontSize: '13px',
    fontWeight: 500,
    color: '#374151',
};

const inputStyle = {
    padding: '10px 12px',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s ease',
    background: '#fff',
    color: '#111827',
};

const selectStyle = {
    ...inputStyle,
    appearance: 'auto',
};

const textareaStyle = {
    ...inputStyle,
    resize: 'vertical',
    fontFamily: 'inherit',
    width: '100%',
};

const formActionStyle = {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
    marginTop: '8px',
    paddingTop: '16px',
    borderTop: '1px solid #F3F4F6',
};

const cancelButtonStyle = {
    padding: '10px 24px',
    background: '#F3F4F6',
    color: '#4B5563',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

const submitButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 28px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
};

// ─── Add-ons Styles ─────────────────────────────────────────────

const addonsGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '8px',
};

const addonCardStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 12px',
    background: '#F9FAFB',
    borderRadius: '8px',
    border: '1px solid #F3F4F6',
};

const checkboxLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    flex: 1,
};

const checkboxStyle = {
    width: '16px',
    height: '16px',
    accentColor: '#e66d33',
    cursor: 'pointer',
};

const addonQuantityStyle = {
    width: '60px',
    padding: '4px 8px',
    border: '1px solid #E5E7EB',
    borderRadius: '6px',
    fontSize: '13px',
    textAlign: 'center',
    background: '#fff',
};

// ─── Dishes Styles ──────────────────────────────────────────────

const dishesGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '6px',
    maxHeight: '160px',
    overflowY: 'auto',
    padding: '4px 2px',
};

const dishCheckboxStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 10px',
    background: '#F9FAFB',
    border: '1px solid #F3F4F6',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    transition: 'all 0.2s ease',
};

const dishPriceStyle = {
    fontSize: '11px',
    color: '#6B7280',
    marginLeft: 'auto',
    fontWeight: 500,
};

const noDishesStyle = {
    color: '#9CA3AF',
    fontSize: '13px',
    padding: '8px 0',
};

// Additional styles for Send Modal
const sendButtonStyle = {
    padding: '6px 10px',
    background: '#8B5CF6',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const sendEnquiryInfoStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '12px',
    padding: '12px 16px',
    background: '#F9FAFB',
    borderRadius: '8px',
    marginBottom: '16px',
    border: '1px solid #E5E7EB',
};

const sendEnquiryInfoItemStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    fontSize: '13px',
};

const selectAllContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 12px',
    background: '#F9FAFB',
    borderRadius: '8px',
    border: '1px solid #E5E7EB',
    marginBottom: '12px',
};

const selectAllLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    fontSize: '14px',
};

const vendorListStyle = {
    maxHeight: '300px',
    overflowY: 'auto',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    padding: '4px',
};

const vendorItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderBottom: '1px solid #F3F4F6',
};

const noVendorsStyle = {
    padding: '20px',
    textAlign: 'center',
    color: '#9CA3AF',
    fontSize: '14px',
};

const dateFilterContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    padding: '0 14px',
    minWidth: '160px',
};

const customDateContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    padding: '4px 12px',
};
// ─── Custom Date Modal Styles ──────────────────────────────────

const customDateModalOverlay = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: '20px',
    animation: 'fadeIn 0.25s ease',
};

const customDateModalStyle = {
    background: '#fff',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
    animation: 'slideUp 0.3s ease',
};

const customDateModalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #F3F4F6',
};

const customDateModalTitle = {
    margin: 0,
    fontSize: '18px',
    fontWeight: 700,
    color: '#111827',
};

const customDateModalClose = {
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#6B7280',
    padding: '4px 8px',
    transition: 'color 0.2s ease',
};

const customDateModalBody = {
    padding: '24px',
};

const customDateModalInputGroup = {
    marginBottom: '16px',
};

const customDateModalLabel = {
    display: 'block',
    fontSize: '13px',
    fontWeight: 500,
    color: '#374151',
    marginBottom: '6px',
};

const customDateModalInput = {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s ease',
    background: '#fff',
    color: '#111827',
    boxSizing: 'border-box',
};

const customDateModalFooter = {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    padding: '16px 24px',
    borderTop: '1px solid #F3F4F6',
};

const customDateModalCancel = {
    padding: '8px 20px',
    background: '#F3F4F6',
    color: '#4B5563',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

const customDateModalApply = {
    padding: '8px 24px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(230, 109, 51, 0.3)',
};
const customDateInputStyle = {
    padding: '6px 8px',
    border: '1px solid #E5E7EB',
    borderRadius: '6px',
    fontSize: '12px',
    outline: 'none',
    background: '#fff',
    color: '#111827',
    width: '130px',
};

const applyDateButtonStyle = {
    padding: '6px 14px',
    background: '#e66d33',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

export default SalesEnquiry;